(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["homescreen"] && !Shopify.designMode) return;
  try {
    
  const track = document.querySelector('.homescreen-track');
  if (track) {
    const labels = Array.from(document.querySelectorAll('.homescreen-label'));
    const subheadings = Array.from(document.querySelectorAll('.homescreen-subheading'));
    const ctas = Array.from(document.querySelectorAll('.homescreen-cta'));
    const prevBtn = document.querySelector('.homescreen-prev');
    const nextBtn = document.querySelector('.homescreen-next');

    // Original brand slides (inspire, shop, studio) — captured before cloning.
    const realSlides = Array.from(track.querySelectorAll('.homescreen-slide'));
    const variantCount = realSlides.length;

    // ── Infinite loop setup (mobile) ──
    // Clone the last slide before the first and the first after the last, so the
    // track reads [studio', inspire, shop, studio, inspire']. When a swipe lands
    // on a clone we silently jump to its real twin — seamless looping both ways.
    // Clones get `lg:hidden` (utility already compiled, used on the controls row)
    // so the desktop lg:grid still lays out exactly 3 columns.
    if (variantCount > 1) {
      const headClone = realSlides[variantCount - 1].cloneNode(true);
      const tailClone = realSlides[0].cloneNode(true);
      [headClone, tailClone].forEach((c, ci) => {
        c.classList.add('lg:hidden');
        c.setAttribute('aria-hidden', 'true');
        c.dataset.clone = 'true';
        // cloneNode copies the SVG `clipPath` ids verbatim, producing
        // duplicate ids in the DOM. Since the head clone is prepended (first
        // in document order), the ORIGINAL slide's `clip-path: url(#id)`
        // would resolve to the clone's clipPath in a different <svg> and fail
        // to clip — rendering that image unmasked/square. Re-id each clone's
        // clipPath (and its referencing element) so every original keeps its
        // own clipPath.
        c.querySelectorAll('clipPath[id]').forEach((cp) => {
          const oldId = cp.id;
          const newId = oldId + '-clone' + ci;
          cp.id = newId;
          c.querySelectorAll('[clip-path="url(#' + oldId + ')"]').forEach((el) => {
            el.setAttribute('clip-path', 'url(#' + newId + ')');
          });
        });
      });
      track.insertBefore(headClone, realSlides[0]);
      track.appendChild(tailClone);
    }

    // All slides in DOM order (incl. clones) + the variant index each maps to.
    const allSlides = Array.from(track.querySelectorAll('.homescreen-slide'));
    const variantOf = allSlides.map((s) =>
      realSlides.findIndex((r) => r.dataset.variant === s.dataset.variant)
    );
    const firstReal = variantCount > 1 ? 1 : 0;
    const lastReal = variantCount > 1 ? variantCount : variantCount - 1;
    const realPosOfVariant = (v) => firstReal + v;

    let currentAll = -1;
    let currentVariant = -1;

    function getSlot(i, active, total) {
      const rel = (i - active + total) % total;
      if (rel === 0) return {col: '2', justify: 'center'};
      if (rel === 1) return {col: '3', justify: 'end'};
      return {col: '1', justify: 'start'};
    }

    function setActive(variant) {
      if (variant === currentVariant) return;

      const isFirst = currentVariant === -1;
      const firsts = isFirst ? null : labels.map((l) => l.getBoundingClientRect().left);

      currentVariant = variant;

      labels.forEach((label, i) => {
        label.classList.toggle('is-active', i === currentVariant);
        const slot = getSlot(i, currentVariant, labels.length);
        label.style.gridColumn = slot.col;
        label.style.justifySelf = slot.justify;
      });
      subheadings.forEach((el, i) => el.classList.toggle('is-active', i === currentVariant));
      ctas.forEach((el, i) => el.classList.toggle('is-active', i === currentVariant));

      // FLIP: slide labels smoothly into their new positions
      if (!isFirst && firsts) {
        requestAnimationFrame(() => {
          labels.forEach((label, i) => {
            const last = label.getBoundingClientRect().left;
            const dx = firsts[i] - last;
            if (Math.abs(dx) < 0.5) return;
            label.animate(
              [{transform: `translateX(${dx}px)`}, {transform: 'translateX(0)'}],
              {duration: 420, easing: 'cubic-bezier(0.4, 0, 0.2, 1)', fill: 'none'}
            );
          });
        });
      }
    }

    // Center a slide in the track. instant = direct scrollLeft (seamless
    // clone→real jump + initial position); otherwise a smooth scroll.
    function centerOn(el, instant) {
      if (!el) return;
      if (instant) {
        const prevBehavior = track.style.scrollBehavior;
        const prevSnap = track.style.scrollSnapType;
        // `scroll-snap-type: x mandatory` re-snaps the track right after a
        // programmatic scrollLeft change, which cancelled the seamless
        // clone→real jump and left the loop dead-ending on touch. Disable
        // snap for the jump, then restore it on the next frame.
        track.style.scrollBehavior = 'auto';
        track.style.scrollSnapType = 'none';
        const delta = el.getBoundingClientRect().left - track.getBoundingClientRect().left;
        track.scrollLeft += delta;
        track.style.scrollBehavior = prevBehavior;
        requestAnimationFrame(() => {
          track.style.scrollSnapType = prevSnap;
        });
      } else {
        el.scrollIntoView({behavior: 'smooth', inline: 'center', block: 'nearest'});
      }
    }

    function goToAll(allIndex, instant) {
      centerOn(allSlides[allIndex], instant);
    }

    prevBtn?.addEventListener('click', () => goToAll(currentAll - 1, false));
    nextBtn?.addEventListener('click', () => goToAll(currentAll + 1, false));
    labels.forEach((label) => {
      label.addEventListener('click', () => {
        const v = parseInt(label.dataset.index, 10);
        if (!isNaN(v)) goToAll(realPosOfVariant(v), false);
      });
    });

    function closestAll() {
      const trackRect = track.getBoundingClientRect();
      const center = trackRect.left + trackRect.width / 2;
      let closest = 0;
      let closestDist = Infinity;
      allSlides.forEach((slide, i) => {
        const r = slide.getBoundingClientRect();
        const dist = Math.abs(r.left + r.width / 2 - center);
        if (dist < closestDist) {
          closestDist = dist;
          closest = i;
        }
      });
      return closest;
    }

    let scrollRaf = 0;
    let idleTimer = 0;
    track.addEventListener('scroll', () => {
      if (!scrollRaf) {
        scrollRaf = requestAnimationFrame(() => {
          const c = closestAll();
          currentAll = c;
          setActive(variantOf[c]);
          scrollRaf = 0;
        });
      }

      // Once the swipe settles on a clone, jump instantly to its real twin.
      clearTimeout(idleTimer);
      idleTimer = setTimeout(() => {
        const c = closestAll();
        if (c < firstReal || c > lastReal) {
          const real = realPosOfVariant(variantOf[c]);
          currentAll = real;
          goToAll(real, true);
        }
      }, 140);
    }, {passive: true});

    // Initialize on Shop (the middle brand), centered, without animation.
    const startVariant = variantCount > 1 ? 1 : 0;
    const startAll = realPosOfVariant(startVariant);
    setActive(startVariant);
    currentAll = startAll;
    centerOn(allSlides[startAll], true);
    requestAnimationFrame(() => centerOn(allSlides[startAll], true));
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["section-about-roots"] && !Shopify.designMode) return;
  try {
    
  (function () {
    /* Items are only hidden once this runs (html.ao-tl-reveal), so they stay
       visible without IntersectionObserver, with reduced motion, and after a
       theme-editor re-render (which re-runs init via shopify:section:load). */
    if (!window.IntersectionObserver) return;
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

    function init(scope) {
      var items = scope.querySelectorAll('[data-ao-tl-item]:not(.is-visible)');
      if (!items.length) return;
      document.documentElement.classList.add('ao-tl-reveal');

      var io = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting) {
              entry.target.classList.add('is-visible');
              io.unobserve(entry.target);
            }
          });
        },
        { threshold: 0.12, rootMargin: '0px 0px -48px 0px' }
      );

      items.forEach(function (item, i) {
        item.style.transitionDelay = i * 0.1 + 's';
        io.observe(item);
      });
    }

    init(document);
    document.addEventListener('shopify:section:load', function (e) { init(e.target); });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["section-about"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-about]').forEach((root) => {
    const imagesEl = root.querySelector('[data-about-images]');
    if (!imagesEl) return;

    let rafId = null;
    const update = () => {
      rafId = null;
      const rect = imagesEl.getBoundingClientRect();
      const vh = window.innerHeight || document.documentElement.clientHeight;
      if (rect.height === 0) return;

      // Visible fraction of the images container from the bottom of the viewport
      const visible = Math.min(vh - rect.top, rect.height);
      const fraction = Math.max(0, Math.min(1, visible / rect.height));

      // Start when 10% in, finish when fully in view
      const progress = Math.max(0, Math.min(1, (fraction - 0.1) / 0.9));
      imagesEl.style.setProperty('--about-progress', progress.toFixed(4));
    };

    const onScroll = () => {
      if (rafId) return;
      rafId = requestAnimationFrame(update);
    };

    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll, { passive: true });
    requestAnimationFrame(update);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["section-article"] && !Shopify.designMode) return;
  try {
    
  function initArticle(root) {
    const scope = root?.matches?.('[data-article-root]')
      ? root
      : root?.querySelector?.('[data-article-root]') ?? document.querySelector('[data-article-root]');
    if (!scope) return;

    const content = scope.querySelector('[data-article-content]');

    const tocList = scope.querySelector('#js-toc-list');
    const tocListSheet = scope.querySelector('#js-toc-list-sheet');
    const toc = scope.querySelector('[data-article-toc]');
    const fab = scope.querySelector('#js-toc-fab');
    const backdrop = scope.querySelector('#js-sheet-backdrop');
    const sheet = scope.querySelector('#js-toc-sheet');
    if (!content || !tocList) return;

    // ── Copy link ──
    const copyToastLabel = scope.dataset.i18nCopyToast || 'Link copied';
    let copyToast = null;
    let copyToastTimer = null;

    function showCopyToast() {
      if (!copyToast) {
        copyToast = document.createElement('div');
        copyToast.className = 'article-copy-toast';
        copyToast.setAttribute('aria-live', 'polite');
        copyToast.innerHTML =
          '<svg viewBox="0 0 16 16" width="14" height="14" fill="none" aria-hidden="true"><path d="M2.5 8.5l3.5 3.5 7-7" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg> ' +
          copyToastLabel;
        document.body.appendChild(copyToast);
      }
      clearTimeout(copyToastTimer);
      copyToast.classList.add('is-visible');
      copyToastTimer = setTimeout(() => copyToast.classList.remove('is-visible'), 2200);
    }

    scope.querySelectorAll('[data-share-copy]').forEach((btn) => {
      btn.addEventListener('click', () => {
        const url = btn.dataset.shareCopy || window.location.href;
        if (navigator.clipboard?.writeText) {
          navigator.clipboard.writeText(url).then(showCopyToast);
        } else {
          const ta = document.createElement('textarea');
          ta.value = url;
          Object.assign(ta.style, { position: 'fixed', opacity: '0', top: '0', left: '0' });
          document.body.appendChild(ta);
          ta.select();
          document.execCommand('copy');
          document.body.removeChild(ta);
          showCopyToast();
        }
      });
    });

    // ── Sheet open / close ──
    let sheetOpen = false;

    const openSheet = () => {
      sheetOpen = true;
      sheet.classList.add('is-open');
      sheet.setAttribute('aria-hidden', 'false');
      backdrop.classList.add('is-open');
      fab.setAttribute('aria-expanded', 'true');
      document.documentElement.classList.add('article-sheet-active');
      window.__lenis?.stop();
    };

    const closeSheet = () => {
      sheetOpen = false;
      sheet.classList.remove('is-open');
      sheet.setAttribute('aria-hidden', 'true');
      backdrop.classList.remove('is-open');
      fab.setAttribute('aria-expanded', 'false');
      document.documentElement.classList.remove('article-sheet-active');
      window.__lenis?.start();
    };

    fab?.addEventListener('click', () => (sheetOpen ? closeSheet() : openSheet()));
    backdrop?.addEventListener('click', closeSheet);
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && sheetOpen) closeSheet();
    });

    if (sheet) {
      let touchStartY = 0;
      sheet.addEventListener(
        'touchstart',
        (e) => {
          touchStartY = e.touches[0].clientY;
        },
        { passive: true }
      );
      sheet.addEventListener(
        'touchend',
        (e) => {
          if (e.changedTouches[0].clientY - touchStartY > 60) closeSheet();
        },
        { passive: true }
      );
    }

    // ── Helpers ──
    const getScrollOffset = () => {
      const body = scope.querySelector('.article-body');
      const raw = body ? getComputedStyle(body).getPropertyValue('--article-scroll-offset').trim() : '';
      const px = parseFloat(raw);
      if (!isNaN(px) && px > 0) return px + 16;
      const header = document.querySelector('header');
      return (header ? header.offsetHeight : 80) + 16;
    };

    const slugify = (text, index) => {
      const base = text
        .trim()
        .toLowerCase()
        .replace(/[^a-z0-9]+/g, '-')
        .replace(/(^-|-$)/g, '');
      return `section-${index + 1}-${base || 'heading'}`;
    };

    const collectHeadings = (container) => {
      // Skip empty headings, like the Liquid TOC does, so links pair by index.
      const native = Array.from(container.querySelectorAll('h2, h3, h4')).filter((h) => h.textContent.trim() !== '');
      if (native.length) return native;
      return Array.from(container.querySelectorAll('p')).filter((p) => {
        if (p.closest('blockquote, li, table')) return false;
        const strong = p.querySelector(':scope > strong, :scope > b');
        if (!strong) return false;
        const label = strong.textContent.trim();
        return label.length >= 3 && label.length <= 120 && p.textContent.trim() === label;
      });
    };

    const scrollToTarget = (target) => {
      if (!target) return;
      const offset = getScrollOffset();
      const lenis = window.__lenis;
      if (lenis?.scrollTo) {
        lenis.scrollTo(target, { offset: -offset, duration: 1.1 });
      } else {
        window.scrollTo({ top: target.getBoundingClientRect().top + window.scrollY - offset, behavior: 'smooth' });
      }
      // replaceState: a TOC jump shouldn't add a history entry (Back must leave the article).
      if (target.id) history.replaceState(history.state, '', '#' + target.id);
    };

    const buildListItem = (heading, index, listEl, baseClass) => {
      const level = heading.tagName;
      const li = document.createElement('li');
      li.className = baseClass + (level === 'H3' ? ` ${baseClass}--h3` : '');
      const a = document.createElement('a');
      a.className = 'p-default';
      if (!heading.id) heading.id = slugify(heading.textContent, index);
      a.href = '#' + heading.id;
      a.textContent = heading.textContent.trim();
      li.appendChild(a);
      listEl.appendChild(li);
      return { li, a, heading };
    };

    // ── Build TOC ──
    let headings = collectHeadings(content);

    if (tocList.children.length === 0 && headings.length > 0) {
      headings.forEach((heading, i) => {
        buildListItem(heading, i, tocList, 'article-toc-item');
        if (tocListSheet) buildListItem(heading, i, tocListSheet, 'article-sheet-toc-item');
      });
    }

    /* Server-rendered TOC (article-toc-items): the desktop list is filled but
       the mobile sheet isn't, so the sheet showed only its label. Mirror it. */
    if (tocListSheet && tocListSheet.children.length === 0 && tocList.children.length > 0) {
      tocList.querySelectorAll('li').forEach((li) => {
        const copy = li.cloneNode(true);
        copy.className = li.className.replace(/article-toc-item/g, 'article-sheet-toc-item');
        copy.classList.remove('is-active');
        tocListSheet.appendChild(copy);
      });
    }

    if (fab && (headings.length > 0 || sheet?.querySelector('.article-sheet-author'))) {
      fab.removeAttribute('hidden');
    }

    let desktopLinks = Array.from(tocList.querySelectorAll('a[href^="#"]'));
    if (desktopLinks.length && headings.length === 0) {
      headings = desktopLinks
        .map((link) => {
          const id = link.getAttribute('href').slice(1);
          try {
            return content.querySelector('#' + CSS.escape(id));
          } catch {
            return content.querySelector(`[id="${id}"]`);
          }
        })
        .filter(Boolean);
    }

    if (headings.length === 0) {
      if (toc) toc.hidden = true;
      return;
    }

    if (toc) toc.hidden = false;

    const setActive = (id) => {
      desktopItems.forEach((item) => {
        const a = item.querySelector('a');
        item.classList.toggle('is-active', !!(a && a.getAttribute('href') === '#' + id));
      });
      sheetItems.forEach((item) => {
        const a = item.querySelector('a');
        item.classList.toggle('is-active', !!(a && a.getAttribute('href') === '#' + id));
      });
    };

    headings.forEach((heading, index) => {
      const link = desktopLinks[index];
      if (link) {
        const id = link.getAttribute('href').slice(1);
        if (id) heading.id = id;
        link.addEventListener('click', (e) => {
          e.preventDefault();
          scrollToTarget(heading);
          setActive(id);
        });
      } else if (!heading.id) {
        heading.id = slugify(heading.textContent, index);
      }
    });

    if (tocListSheet) {
      Array.from(tocListSheet.querySelectorAll('a[href^="#"]')).forEach((link, index) => {
        const heading = headings[index];
        if (!heading) return;
        const id = link.getAttribute('href').slice(1);
        link.addEventListener('click', (e) => {
          e.preventDefault();
          closeSheet();
          setTimeout(() => {
            scrollToTarget(heading);
            setActive(id);
          }, 360);
        });
      });
    }

    const desktopItems = Array.from(tocList.querySelectorAll('li'));
    const sheetItems = tocListSheet ? Array.from(tocListSheet.querySelectorAll('li')) : [];

    const updateActiveFromScroll = () => {
      const offset = getScrollOffset();
      const triggerZone = offset + Math.min(window.innerHeight * 0.3, 220);
      let current = null;
      headings.forEach((h) => {
        if (h.getBoundingClientRect().top <= triggerZone) current = h;
      });
      if (current?.id) {
        setActive(current.id);
      } else {
        desktopItems.forEach((item) => item.classList.remove('is-active'));
        sheetItems.forEach((item) => item.classList.remove('is-active'));
      }
    };

    let ticking = false;
    const onScroll = () => {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(() => {
        updateActiveFromScroll();
        ticking = false;
      });
    };

    window.addEventListener('scroll', onScroll, { passive: true });
    window.__lenis?.on?.('scroll', onScroll);

    updateActiveFromScroll();

    if (window.location.hash) {
      let hashId = window.location.hash.slice(1);
      try { hashId = decodeURIComponent(hashId); } catch (e) {}
      const hashTarget = document.getElementById(hashId);
      if (hashTarget && content.contains(hashTarget))
        setTimeout(() => {
          scrollToTarget(hashTarget);
          setActive(hashTarget.id);
        }, 150);
    }

  }

  function syncArticleScrollOffset() {
    const header = document.querySelector('header');
    if (!header) return;
    const h = header.offsetHeight + 80;
    document.querySelectorAll('.article-body').forEach((el) => {
      el.style.setProperty('--article-scroll-offset', h + 'px');
    });
  }
  syncArticleScrollOffset();
  window.addEventListener('resize', syncArticleScrollOffset);

  document.querySelectorAll('[data-article-root]').forEach(initArticle);
  document.addEventListener('shopify:section:load', (e) => initArticle(e.target));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["section-featured-projects"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-projects-section]').forEach((root) => {
    const slider = root.querySelector('[data-slider]');
    const prevBtn = root.querySelector('[data-slider-prev]');
    const nextBtn = root.querySelector('[data-slider-next]');

    if (!slider) return;

    const stepSize = () => {
      const card = slider.querySelector(':scope > *');
      if (!card) return 0;
      const gap = parseFloat(getComputedStyle(slider).gap) || 0;
      return card.offsetWidth + gap;
    };

    let rafId = null;
    const update = () => {
      if (rafId) return;
      rafId = requestAnimationFrame(() => {
        const max = slider.scrollWidth - slider.clientWidth;
        if (prevBtn) prevBtn.disabled = slider.scrollLeft <= 2;
        if (nextBtn) nextBtn.disabled = slider.scrollLeft >= max - 2;
        rafId = null;
      });
    };

    prevBtn?.addEventListener('click', () => {
      slider.scrollBy({ left: -stepSize(), behavior: 'smooth' });
    });
    nextBtn?.addEventListener('click', () => {
      slider.scrollBy({ left: stepSize(), behavior: 'smooth' });
    });

    slider.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update, { passive: true });
    requestAnimationFrame(update);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["section-inspire-category-collections"]) return;
  try {
    
  document.querySelectorAll('[data-collections-section]').forEach(function (section) {
    var trigger = section.querySelector('[data-filters-trigger]');
    var panel = section.querySelector('[data-filters-panel]');
    var backdrop = section.querySelector('[data-filters-backdrop]');
    var grid = section.querySelector('[data-collections-grid]');
    if (!trigger || !panel || !backdrop || !grid) return;

    var closeEls = panel.querySelectorAll('[data-filters-close]');
    var countBadge = trigger.querySelector('[data-filter-count]');
    var resetBtn = panel.querySelector('[data-filter-reset]');
    var emptyMsg = section.querySelector('[data-collections-empty]');
    var pagination = section.querySelector('[data-pagination]');
    var cards = Array.from(grid.querySelectorAll('[data-collection-item]'));
    var lastFocus = null;

    // ── Build panel option lists from rendered card data ──
    // Server-side rendered cards carry the brand handle/name/logo and a
    // `handle|name~~~handle|name` mood meta string. We dedupe both sets
    // here so the panel reflects exactly what's on the page.
    function buildOptions() {
      var brandList = panel.querySelector('[data-filter-list="brand"]');
      var moodList = panel.querySelector('[data-filter-list="mood"]');
      if (!brandList || !moodList) return;

      var brandsSeen = {};
      var moodsSeen = {};
      var brandsHTML = '';
      var moodsHTML = '';

      cards.forEach(function (card) {
        var brand = card.getAttribute('data-merk');
        var brandName = card.getAttribute('data-merk-name');
        var brandLogo = card.getAttribute('data-merk-logo');
        if (brand && brandName && !brandsSeen[brand]) {
          brandsSeen[brand] = true;
          var initial = brandName.charAt(0).toUpperCase();
          var logoHTML = brandLogo
            ? '<img src="' + brandLogo + '" width="32" height="32" alt="" class="filter-option-logo">'
            : '<span class="filter-option-logo-fallback">' + initial + '</span>';
          brandsHTML +=
            '<li class="filter-option" data-filter-option data-filter-type="brand"' +
            ' data-filter-value="' + brand + '"' +
            ' data-filter-label="' + brandName.toLowerCase() + '">' +
            '<label class="filter-option-label">' +
              '<input type="checkbox" value="' + brand + '" class="filter-option-checkbox" data-filter-checkbox data-filter-type="brand">' +
              '<span class="filter-option-logo-frame" aria-hidden="true">' + logoHTML + '</span>' +
              '<span class="filter-option-text">' + brandName + '</span>' +
              '<span class="filter-option-check" aria-hidden="true">' +
                '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"><polyline points="20 6 9 17 4 12"/></svg>' +
              '</span>' +
            '</label></li>';
        }

        var meta = card.getAttribute('data-moods-meta') || '';
        meta.split('~~~').forEach(function (pair) {
          if (!pair) return;
          var parts = pair.split('|');
          var h = parts[0];
          var n = parts.slice(1).join('|');
          if (!h || !n || moodsSeen[h]) return;
          moodsSeen[h] = true;
          moodsHTML +=
            '<li class="filter-option filter-option--mood" data-filter-option data-filter-type="mood"' +
            ' data-filter-value="' + h + '"' +
            ' data-filter-label="' + n.toLowerCase() + '">' +
            '<label class="filter-option-label">' +
              '<input type="checkbox" value="' + h + '" class="filter-option-checkbox" data-filter-checkbox data-filter-type="mood">' +
              '<span class="filter-option-text">' + n + '</span>' +
              '<span class="filter-option-check" aria-hidden="true">' +
                '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"><polyline points="20 6 9 17 4 12"/></svg>' +
              '</span>' +
            '</label></li>';
        });
      });

      brandList.innerHTML = brandsHTML;
      moodList.innerHTML = moodsHTML;

      // Hide the entire group if it has no options at all.
      var brandGroup = panel.querySelector('[data-filter-group="brand"]');
      var moodGroup = panel.querySelector('[data-filter-group="mood"]');
      if (brandGroup) brandGroup.hidden = brandsHTML === '';
      if (moodGroup) moodGroup.hidden = moodsHTML === '';
    }
    buildOptions();

    function openPanel() {
      lastFocus = document.activeElement;
      panel.hidden = false;
      backdrop.hidden = false;
      // Force reflow so the .is-open transition runs from the initial state.
      void panel.offsetWidth;
      panel.classList.add('is-open');
      backdrop.classList.add('is-open');
      trigger.setAttribute('aria-expanded', 'true');
      document.body.classList.add('collections-filters-locked');
      if (window.__lenis) window.__lenis.stop();
      var firstInput = panel.querySelector('input[type="search"], [data-filter-checkbox]');
      if (firstInput) firstInput.focus();
    }

    function closePanel() {
      panel.classList.remove('is-open');
      backdrop.classList.remove('is-open');
      trigger.setAttribute('aria-expanded', 'false');
      document.body.classList.remove('collections-filters-locked');
      if (window.__lenis) window.__lenis.start();
      setTimeout(function () {
        if (!panel.classList.contains('is-open')) {
          panel.hidden = true;
          backdrop.hidden = true;
        }
      }, 360);
      if (lastFocus && lastFocus.focus) lastFocus.focus();
    }

    trigger.addEventListener('click', openPanel);
    backdrop.addEventListener('click', closePanel);
    closeEls.forEach(function (el) { el.addEventListener('click', closePanel); });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && panel.classList.contains('is-open')) closePanel();
    });

    // ── Search within each list ──
    section.querySelectorAll('[data-filter-search]').forEach(function (input) {
      var type = input.getAttribute('data-filter-search');
      var list = section.querySelector('[data-filter-list="' + type + '"]');
      var empty = section.querySelector('[data-filter-list-empty="' + type + '"]');
      if (!list) return;
      input.addEventListener('input', function () {
        var q = input.value.trim().toLowerCase();
        var visible = 0;
        list.querySelectorAll('[data-filter-option]').forEach(function (opt) {
          var label = opt.getAttribute('data-filter-label') || '';
          var hit = !q || label.indexOf(q) !== -1;
          opt.classList.toggle('is-hidden', !hit);
          if (hit) visible++;
        });
        if (empty) empty.hidden = visible > 0;
      });
    });

    // ── Filter application with pagination support ──
    // When filters are active we clone the server-rendered pagination
    // nav (which detaches the snippet's click listeners), then take it
    // over with our own handlers that page through the filtered subset
    // at the same 12-items-per-page rate. On clear, we restore the
    // original pagination HTML and re-init via `collection:refreshed`.
    var ORIGINAL_PAGINATION = pagination ? pagination.outerHTML : null;
    var inFilterMode = false;
    var filterCurrent = 1;
    var filterTotal = 1;
    var pageSize = 12;
    var matchedRef = [];

    function readSelected(type) {
      var out = [];
      section.querySelectorAll('[data-filter-checkbox][data-filter-type="' + type + '"]:checked').forEach(function (cb) {
        out.push(cb.value);
      });
      return out;
    }

    function passesFilter(card, selBrands, selMoods) {
      if (selBrands.length) {
        var brand = card.getAttribute('data-merk') || '';
        if (selBrands.indexOf(brand) === -1) return false;
      }
      if (selMoods.length) {
        var moods = (card.getAttribute('data-moods') || '').split(',').filter(Boolean);
        var ok = false;
        for (var i = 0; i < moods.length; i++) {
          if (selMoods.indexOf(moods[i]) !== -1) { ok = true; break; }
        }
        if (!ok) return false;
      }
      return true;
    }

    function visibleSet(cur, total) {
      if (total <= 5) {
        var arr = []; for (var i = 1; i <= total; i++) arr.push(i);
        return new Set(arr);
      }
      if (cur <= 3) return new Set([1, 2, 3, 4, total]);
      if (cur >= total - 2) return new Set([1, total - 3, total - 2, total - 1, total]);
      return new Set([1, cur - 1, cur, cur + 1, total]);
    }

    function scrollToTop() {
      var rect = grid.getBoundingClientRect();
      var y = window.scrollY + rect.top - 120;
      var targetY = Math.max(0, y);
      if (window.__lenis && window.__lenis.scrollTo) {
        window.__lenis.scrollTo(targetY, { duration: 0.6 });
      } else {
        window.scrollTo({ top: targetY, behavior: 'smooth' });
      }
    }

    function enterFilterMode() {
      if (!pagination || !ORIGINAL_PAGINATION) return;
      var wrapper = document.createElement('div');
      wrapper.innerHTML = ORIGINAL_PAGINATION;
      var clone = wrapper.firstElementChild;
      pagination.replaceWith(clone);
      pagination = clone;
      attachFilterClickHandlers(clone);
    }

    function exitFilterMode() {
      if (!pagination || !ORIGINAL_PAGINATION) return;
      var wrapper = document.createElement('div');
      wrapper.innerHTML = ORIGINAL_PAGINATION;
      var fresh = wrapper.firstElementChild;
      pagination.replaceWith(fresh);
      pagination = fresh;
      // The snippet's init runs on this fresh node since it's not in
      // the WeakSet of already-initialised navs.
      document.dispatchEvent(new CustomEvent('collection:refreshed'));
    }

    function attachFilterClickHandlers(nav) {
      nav.querySelectorAll('button.collections-pagination-page').forEach(function (btn) {
        btn.addEventListener('click', function () {
          var target = parseInt(btn.dataset.page, 10);
          if (target >= 1 && target <= filterTotal) {
            filterCurrent = target;
            applyVisibility();
            updatePaginationUI();
            scrollToTop();
          }
        });
      });
      var prev = nav.querySelector('[data-prev]');
      var next = nav.querySelector('[data-next]');
      if (prev) prev.addEventListener('click', function () {
        if (filterCurrent > 1) {
          filterCurrent--;
          applyVisibility();
          updatePaginationUI();
          scrollToTop();
        }
      });
      if (next) next.addEventListener('click', function () {
        if (filterCurrent < filterTotal) {
          filterCurrent++;
          applyVisibility();
          updatePaginationUI();
          scrollToTop();
        }
      });
    }

    function applyVisibility() {
      if (inFilterMode) {
        var start = (filterCurrent - 1) * pageSize;
        var end = start + pageSize;
        cards.forEach(function (card) {
          var idx = matchedRef.indexOf(card);
          var show = idx >= start && idx < end;
          card.classList.toggle('is-hidden', !show);
        });
      } else {
        cards.forEach(function (card) {
          var p = parseInt(card.getAttribute('data-page'), 10);
          card.classList.toggle('is-hidden', p !== 1);
        });
      }
    }

    function updatePaginationUI() {
      if (!pagination) return;
      if (filterTotal <= 1) {
        pagination.hidden = true;
        return;
      }
      pagination.hidden = false;
      pagination.dataset.totalPages = String(filterTotal);

      var vis = visibleSet(filterCurrent, filterTotal);
      pagination.querySelectorAll('[data-page-slot]').forEach(function (slot) {
        var p = parseInt(slot.dataset.pageSlot, 10);
        slot.hidden = !vis.has(p) || p > filterTotal;
      });
      var sorted = Array.from(vis).sort(function (a, b) { return a - b; });
      var minMid = sorted[1];
      var maxMid = sorted[sorted.length - 2];
      var ellipsisBefore = pagination.querySelector('[data-ellipsis-before]');
      var ellipsisAfter = pagination.querySelector('[data-ellipsis-after]');
      if (ellipsisBefore) ellipsisBefore.hidden = !(filterTotal > 2 && minMid > 2);
      if (ellipsisAfter) ellipsisAfter.hidden = !(filterTotal > 2 && maxMid < filterTotal - 1);

      pagination.querySelectorAll('button.collections-pagination-page').forEach(function (btn) {
        var bp = parseInt(btn.dataset.page, 10);
        var isCur = bp === filterCurrent;
        btn.classList.toggle('is-current', isCur);
        if (isCur) btn.setAttribute('aria-current', 'page');
        else btn.removeAttribute('aria-current');
      });

      var prev = pagination.querySelector('[data-prev]');
      var next = pagination.querySelector('[data-next]');
      if (prev) prev.disabled = filterCurrent === 1;
      if (next) next.disabled = filterCurrent === filterTotal;
    }

    function recompute() {
      var selBrands = readSelected('brand');
      var selMoods = readSelected('mood');
      var totalFilters = selBrands.length + selMoods.length;
      var anyActive = totalFilters > 0;

      if (countBadge) {
        countBadge.hidden = totalFilters === 0;
        countBadge.textContent = String(totalFilters);
      }

      if (!anyActive) {
        if (inFilterMode) {
          exitFilterMode();
          inFilterMode = false;
        }
        matchedRef = [];
        filterCurrent = 1;
        filterTotal = 1;
        applyVisibility();
        if (emptyMsg) emptyMsg.hidden = true;
        return;
      }

      matchedRef = cards.filter(function (card) { return passesFilter(card, selBrands, selMoods); });
      filterTotal = Math.max(1, Math.ceil(matchedRef.length / pageSize));
      if (filterCurrent > filterTotal) filterCurrent = filterTotal;

      if (!inFilterMode) {
        enterFilterMode();
        inFilterMode = true;
      }

      applyVisibility();
      updatePaginationUI();
      if (emptyMsg) emptyMsg.hidden = matchedRef.length > 0;
    }

    function onFilterChange() {
      filterCurrent = 1;
      recompute();
    }

    section.querySelectorAll('[data-filter-checkbox]').forEach(function (cb) {
      cb.addEventListener('change', onFilterChange);
    });

    if (resetBtn) {
      resetBtn.addEventListener('click', function () {
        section.querySelectorAll('[data-filter-checkbox]:checked').forEach(function (cb) {
          cb.checked = false;
        });
        section.querySelectorAll('[data-filter-search]').forEach(function (input) {
          input.value = '';
          input.dispatchEvent(new Event('input'));
        });
        filterCurrent = 1;
        recompute();
      });
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["section-inspire-category-media"]) return;
  try {
    
  /* ── Lightbox (single instance per page) ── */
  const lightbox = document.querySelector('[data-media-lightbox]');
  if (lightbox) {
    const lbImg = lightbox.querySelector('[data-lightbox-img]');
    const lbCounter = lightbox.querySelector('[data-lightbox-counter]');
    const lbCloseEls = lightbox.querySelectorAll('[data-lightbox-close]');
    const lbPrev = lightbox.querySelector('[data-lightbox-prev]');
    const lbNext = lightbox.querySelector('[data-lightbox-next]');

    let items = [];
    let current = -1;
    let lastFocus = null;

    const refreshItems = (sourceGrid) => {
      items = Array.from(sourceGrid.querySelectorAll('[data-media-item]'));
    };

    const updateCounter = () => {
      if (lbCounter && items.length) {
        lbCounter.textContent = `${current + 1} / ${items.length}`;
      }
    };

    const showAt = (index) => {
      if (!items.length) return;
      current = ((index % items.length) + items.length) % items.length;
      const item = items[current];
      const src = item.dataset.src;
      const alt = item.dataset.alt || '';
      lbImg.src = src;
      lbImg.alt = alt;
      updateCounter();
    };

    const open = (index) => {
      lastFocus = document.activeElement;
      showAt(index);
      lightbox.classList.add('is-open');
      lightbox.setAttribute('aria-hidden', 'false');
      document.body.classList.add('media-lightbox-locked');
      if (window.__lenis) window.__lenis.stop();
    };

    const close = () => {
      lightbox.classList.remove('is-open');
      lightbox.setAttribute('aria-hidden', 'true');
      document.body.classList.remove('media-lightbox-locked');
      if (window.__lenis) window.__lenis.start();
      // Wait for the close transition before clearing the source so the image
      // doesn't disappear during the fade-out.
      setTimeout(() => {
        if (!lightbox.classList.contains('is-open')) lbImg.src = '';
      }, 500);
      if (lastFocus && typeof lastFocus.focus === 'function') lastFocus.focus();
    };

    /* Wire each section's items to open the shared lightbox */
    document.querySelectorAll('[data-media-grid]').forEach((grid) => {
      grid.addEventListener('click', (e) => {
        const item = e.target.closest('[data-media-item]');
        if (!item) return;
        refreshItems(grid);
        const idx = items.indexOf(item);
        if (idx >= 0) open(idx);
      });
    });

    lbCloseEls.forEach((el) => el.addEventListener('click', close));
    lbPrev?.addEventListener('click', () => showAt(current - 1));
    lbNext?.addEventListener('click', () => showAt(current + 1));

    document.addEventListener('keydown', (e) => {
      if (!lightbox.classList.contains('is-open')) return;
      if (e.key === 'Escape') close();
      else if (e.key === 'ArrowLeft') showAt(current - 1);
      else if (e.key === 'ArrowRight') showAt(current + 1);
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["section-inspire-collectie-media"]) return;
  try {
    
  /* Lightbox with image + video support. */
  const lightbox = document.querySelector('.collectie-media-lightbox');
  if (lightbox) {
    const lbImg = lightbox.querySelector('[data-lightbox-img]');
    const lbVid = lightbox.querySelector('[data-lightbox-video]');
    const lbCounter = lightbox.querySelector('[data-lightbox-counter]');
    const lbCloseEls = lightbox.querySelectorAll('[data-lightbox-close]');
    const lbPrev = lightbox.querySelector('[data-lightbox-prev]');
    const lbNext = lightbox.querySelector('[data-lightbox-next]');

    let items = [];
    let current = -1;
    let lastFocus = null;

    const refreshItems = (sourceGrid) => {
      items = Array.from(sourceGrid.querySelectorAll('[data-media-item]'));
    };

    const updateCounter = () => {
      if (lbCounter && items.length) {
        lbCounter.textContent = `${current + 1} / ${items.length}`;
      }
    };

    const showAt = (index) => {
      if (!items.length) return;
      current = ((index % items.length) + items.length) % items.length;
      const item = items[current];
      const type = item.dataset.mediaType || 'image';
      const src = item.dataset.src;
      const alt = item.dataset.alt || '';

      // Pause any previous video.
      try { lbVid.pause(); } catch (_) {}
      lbVid.removeAttribute('src');

      if (type === 'video') {
        lbImg.hidden = true;
        lbImg.src = '';
        lbVid.hidden = false;
        if (item.dataset.poster) lbVid.poster = item.dataset.poster;
        lbVid.src = src;
        lbVid.load();
      } else {
        lbVid.hidden = true;
        lbImg.hidden = false;
        lbImg.src = src;
        lbImg.alt = alt;
      }

      updateCounter();
    };

    const open = (index) => {
      lastFocus = document.activeElement;
      showAt(index);
      lightbox.classList.add('is-open');
      lightbox.setAttribute('aria-hidden', 'false');
      document.body.classList.add('media-lightbox-locked');
      if (window.__lenis) window.__lenis.stop();
    };

    const close = () => {
      lightbox.classList.remove('is-open');
      lightbox.setAttribute('aria-hidden', 'true');
      document.body.classList.remove('media-lightbox-locked');
      if (window.__lenis) window.__lenis.start();
      try { lbVid.pause(); } catch (_) {}
      setTimeout(() => {
        if (!lightbox.classList.contains('is-open')) {
          lbImg.src = '';
          lbVid.removeAttribute('src');
        }
      }, 500);
      if (lastFocus && typeof lastFocus.focus === 'function') lastFocus.focus();
    };

    document.querySelectorAll('.collectie-media-grid').forEach((grid) => {
      grid.addEventListener('click', (e) => {
        const item = e.target.closest('[data-media-item]');
        if (!item) return;
        refreshItems(grid);
        const idx = items.indexOf(item);
        if (idx >= 0) open(idx);
      });
    });

    lbCloseEls.forEach((el) => el.addEventListener('click', close));
    lbPrev?.addEventListener('click', () => showAt(current - 1));
    lbNext?.addEventListener('click', () => showAt(current + 1));

    document.addEventListener('keydown', (e) => {
      if (!lightbox.classList.contains('is-open')) return;
      if (e.key === 'Escape') close();
      else if (e.key === 'ArrowLeft') showAt(current - 1);
      else if (e.key === 'ArrowRight') showAt(current + 1);
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["section-inspire-collectie-related"]) return;
  try {
    
  document.querySelectorAll('[data-related-track]').forEach((track) => {
    const root = track.closest('.collectie-related');
    const prev = root?.querySelector('[data-related-prev]');
    const next = root?.querySelector('[data-related-next]');
    if (!prev || !next) return;

    const slideWidth = () => {
      const slide = track.querySelector('.collectie-related-slide');
      if (!slide) return track.clientWidth;
      const styles = getComputedStyle(track);
      const gap = parseFloat(styles.columnGap || styles.gap || '0');
      return slide.getBoundingClientRect().width + gap;
    };

    const updateButtons = () => {
      const max = track.scrollWidth - track.clientWidth - 1;
      prev.disabled = track.scrollLeft <= 0;
      next.disabled = track.scrollLeft >= max;
    };

    prev.addEventListener('click', () => {
      track.scrollBy({ left: -slideWidth(), behavior: 'smooth' });
    });
    next.addEventListener('click', () => {
      track.scrollBy({ left: slideWidth(), behavior: 'smooth' });
    });

    track.addEventListener('scroll', updateButtons, { passive: true });
    window.addEventListener('resize', updateButtons);
    updateButtons();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["section-inspire-collectie-video"]) return;
  try {
    
  document.querySelectorAll('[data-video-frame]').forEach((frame) => {
    const cover = frame.querySelector('[data-video-cover]');
    const iframe = frame.querySelector('[data-video-iframe]');
    if (!cover || !iframe) return;

    cover.addEventListener('click', () => {
      frame.classList.add('is-active');
      try {
        iframe.contentWindow.postMessage(
          '{"event":"command","func":"playVideo","args":""}',
          '*'
        );
      } catch (_) {}
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["section-inspire-hero"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('.inspire-hero-slider').forEach((root) => {
    const thumbs = Array.from(root.querySelectorAll('.inspire-hero-slider__thumb'));
    const mains = Array.from(root.querySelectorAll('.inspire-hero-slider__main'));
    const texts = Array.from(root.querySelectorAll('.inspire-hero-slider__text'));
    const bars = Array.from(root.querySelectorAll('.inspire-hero-slider__bar'));
    const prev = root.querySelector('[data-prev]');
    const next = root.querySelector('[data-next]');
    const total = Math.max(mains.length, texts.length);
    if (total <= 1) return;

    const intervalMs = 6000;
    root.style.setProperty('--inspire-hero-duration', `${intervalMs}ms`);

    let index = 0;
    let timer = null;
    let pausedHover = false;
    let pausedVisibility = false;

    const isPaused = () => pausedHover || pausedVisibility;

    const render = () => {
      const previewIndex = (index + 1) % total;
      thumbs.forEach((el, i) => el.classList.toggle('is-active', i === previewIndex));
      mains.forEach((el, i) => el.classList.toggle('is-active', i === index));
      texts.forEach((el, i) => {
        el.classList.toggle('is-active', i === index);
        el.setAttribute('aria-hidden', i === index ? 'false' : 'true');
      });
      bars.forEach((el, i) => {
        el.classList.toggle('is-complete', i < index);
        el.classList.toggle('is-active', i === index);
      });
    };

    const stopTimer = () => {
      if (timer) {
        clearTimeout(timer);
        timer = null;
      }
    };

    const restartActiveBar = () => {
      const bar = bars[index];
      if (!bar) return;
      bar.classList.remove('is-active');
      void bar.offsetWidth;
      bar.classList.add('is-active');
    };

    const schedule = () => {
      stopTimer();
      if (isPaused()) return;
      restartActiveBar();
      timer = setTimeout(() => goTo(index + 1), intervalMs);
    };

    const goTo = (i) => {
      index = ((i % total) + total) % total;
      render();
      schedule();
    };

    const syncPaused = () => {
      root.classList.toggle('is-paused', isPaused());
      if (isPaused()) stopTimer();
      else schedule();
    };

    prev?.addEventListener('click', () => goTo(index - 1));
    next?.addEventListener('click', () => goTo(index + 1));

    root.addEventListener('keydown', (e) => {
      if (e.key === 'ArrowLeft') {
        e.preventDefault();
        goTo(index - 1);
      } else if (e.key === 'ArrowRight') {
        e.preventDefault();
        goTo(index + 1);
      }
    });

    root.addEventListener('mouseenter', () => {
      pausedHover = true;
      syncPaused();
    });
    root.addEventListener('mouseleave', () => {
      pausedHover = false;
      syncPaused();
    });
    root.addEventListener('focusin', () => {
      pausedHover = true;
      syncPaused();
    });
    root.addEventListener('focusout', () => {
      pausedHover = false;
      syncPaused();
    });

    if ('IntersectionObserver' in window) {
      const io = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            pausedVisibility = !entry.isIntersecting;
            syncPaused();
          });
        },
        { threshold: 0 }
      );
      io.observe(root);
    }

    render();
    schedule();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["section-inspire-merken-media"]) return;
  try {
    
  /* ── Lightbox (shared with category-media via generic data-* hooks) ── */
  const lightbox = document.querySelector('[data-media-lightbox]');
  if (lightbox) {
    const lbImg = lightbox.querySelector('[data-lightbox-img]');
    const lbCounter = lightbox.querySelector('[data-lightbox-counter]');
    const lbCloseEls = lightbox.querySelectorAll('[data-lightbox-close]');
    const lbPrev = lightbox.querySelector('[data-lightbox-prev]');
    const lbNext = lightbox.querySelector('[data-lightbox-next]');

    let items = [];
    let current = -1;
    let lastFocus = null;

    const refreshItems = (sourceGrid) => {
      items = Array.from(sourceGrid.querySelectorAll('[data-media-item]'));
    };

    const updateCounter = () => {
      if (lbCounter && items.length) {
        lbCounter.textContent = `${current + 1} / ${items.length}`;
      }
    };

    const showAt = (index) => {
      if (!items.length) return;
      current = ((index % items.length) + items.length) % items.length;
      const item = items[current];
      const src = item.dataset.src;
      const alt = item.dataset.alt || '';
      lbImg.src = src;
      lbImg.alt = alt;
      updateCounter();
    };

    const open = (index) => {
      lastFocus = document.activeElement;
      showAt(index);
      lightbox.classList.add('is-open');
      lightbox.setAttribute('aria-hidden', 'false');
      document.body.classList.add('media-lightbox-locked');
      if (window.__lenis) window.__lenis.stop();
    };

    const close = () => {
      lightbox.classList.remove('is-open');
      lightbox.setAttribute('aria-hidden', 'true');
      document.body.classList.remove('media-lightbox-locked');
      if (window.__lenis) window.__lenis.start();
      setTimeout(() => {
        if (!lightbox.classList.contains('is-open')) lbImg.src = '';
      }, 500);
      if (lastFocus && typeof lastFocus.focus === 'function') lastFocus.focus();
    };

    document.querySelectorAll('[data-media-grid]').forEach((grid) => {
      grid.addEventListener('click', (e) => {
        const item = e.target.closest('[data-media-item]');
        if (!item) return;
        refreshItems(grid);
        const idx = items.indexOf(item);
        if (idx >= 0) open(idx);
      });
    });

    lbCloseEls.forEach((el) => el.addEventListener('click', close));
    lbPrev?.addEventListener('click', () => showAt(current - 1));
    lbNext?.addEventListener('click', () => showAt(current + 1));

    document.addEventListener('keydown', (e) => {
      if (!lightbox.classList.contains('is-open')) return;
      if (e.key === 'Escape') close();
      else if (e.key === 'ArrowLeft') showAt(current - 1);
      else if (e.key === 'ArrowRight') showAt(current + 1);
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["section-inspire-merken-video"]) return;
  try {
    
  document.querySelectorAll('[data-video-frame]').forEach((frame) => {
    const cover = frame.querySelector('[data-video-cover]');
    const iframe = frame.querySelector('[data-video-iframe]');
    if (!cover || !iframe) return;

    cover.addEventListener('click', () => {
      frame.classList.add('is-active');
      try {
        iframe.contentWindow.postMessage(
          '{"event":"command","func":"playVideo","args":""}',
          '*'
        );
      } catch (_) {}
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["section-inspire-mood-detail"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-mood-detail-root]').forEach((root) => {
    const grid = root.querySelector('[data-mood-detail-gallery-grid]');
    if (!grid) return;

    // ── Scroll-reveal ──
    // No per-column stagger: column 4 used to wait 210ms behind column
    // 1, which compounded with the source-order lazy bias on the right
    // columns and read as "bottom-up loading". Each brick now reveals
    // the moment its IntersectionObserver fires, so visual order ≈
    // viewport-Y order.
    const io = 'IntersectionObserver' in window
      ? new IntersectionObserver((entries) => {
          entries.forEach((entry) => {
            if (!entry.isIntersecting) return;
            io.unobserve(entry.target);
            entry.target.classList.add('masonry-revealed');
          });
        }, { rootMargin: '0px 0px -30px 0px', threshold: 0.05 })
      : null;

    const observeVisible = () => {
      Array.from(grid.querySelectorAll('.mood-detail-masonry__brick')).forEach((brick) => {
        if (io) io.unobserve(brick);
        brick.classList.remove('masonry-revealed');
        if (!brick.classList.contains('is-hidden')) {
          if (io) io.observe(brick);
          else brick.classList.add('masonry-revealed');
        }
      });
    };

    observeVisible();

    // ── Pagination transition ──
    const paginationNav = root.querySelector('[data-pagination]');
    if (paginationNav) {
      paginationNav.addEventListener('click', (e) => {
        if (!e.target.closest('button[data-page], [data-prev], [data-next]')) return;
        setTimeout(() => observeVisible(), 0);
      }, true);
    }

    // ── Lightbox ──
    const lightbox = root.querySelector('[data-mood-detail-lightbox]');
    if (!lightbox) return;
    const lbImg = lightbox.querySelector('[data-mood-detail-lightbox-img]');
    const lbCounter = lightbox.querySelector('[data-mood-detail-lightbox-counter]');
    const lbCloseEls = lightbox.querySelectorAll('[data-mood-detail-lightbox-close]');
    const lbPrev = lightbox.querySelector('[data-mood-detail-lightbox-prev]');
    const lbNext = lightbox.querySelector('[data-mood-detail-lightbox-next]');

    const visibleItems = () => Array.from(grid.querySelectorAll('[data-mood-detail-gallery-item]')).filter(
      (el) => !el.closest('.mood-detail-masonry__brick')?.classList.contains('is-hidden')
    );

    let current = -1;
    let lastFocus = null;

    const updateCounter = (items) => {
      if (lbCounter && items.length) lbCounter.textContent = `${current + 1} / ${items.length}`;
    };

    const showAt = (index) => {
      const items = visibleItems();
      if (!items.length) return;
      current = ((index % items.length) + items.length) % items.length;
      const item = items[current];
      if (lbImg) { lbImg.src = item.dataset.src || ''; lbImg.alt = item.dataset.alt || ''; }
      updateCounter(items);
    };

    const open = (index) => {
      lastFocus = document.activeElement;
      showAt(index);
      lightbox.classList.add('is-open');
      lightbox.setAttribute('aria-hidden', 'false');
      document.body.classList.add('mood-detail-lightbox-locked');
      if (window.__lenis) window.__lenis.stop();
    };

    const close = () => {
      lightbox.classList.remove('is-open');
      lightbox.setAttribute('aria-hidden', 'true');
      document.body.classList.remove('mood-detail-lightbox-locked');
      if (window.__lenis) window.__lenis.start();
      setTimeout(() => { if (!lightbox.classList.contains('is-open') && lbImg) lbImg.removeAttribute('src'); }, 500);
      if (lastFocus?.focus) lastFocus.focus();
    };

    grid.addEventListener('click', (e) => {
      const item = e.target.closest('[data-mood-detail-gallery-item]');
      if (!item) return;
      const items = visibleItems();
      const idx = items.indexOf(item);
      if (idx >= 0) open(idx);
    });

    lbCloseEls.forEach((el) => el.addEventListener('click', close));
    lbPrev?.addEventListener('click', () => showAt(current - 1));
    lbNext?.addEventListener('click', () => showAt(current + 1));

    document.addEventListener('keydown', (e) => {
      if (!lightbox.classList.contains('is-open')) return;
      if (e.key === 'Escape') close();
      else if (e.key === 'ArrowLeft') showAt(current - 1);
      else if (e.key === 'ArrowRight') showAt(current + 1);
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["section-inspire-moods-masonry"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-inspire-moods-masonry-root]').forEach((root) => {
    const grid = root.querySelector('[data-inspire-moods-masonry-grid]');
    if (!grid) return;

    // ── Scroll-reveal ──
    const getColDelay = (brick) => {
      const gRect = grid.getBoundingClientRect();
      if (!gRect.width) return 0;
      const bRect = brick.getBoundingClientRect();
      const cols = window.innerWidth >= 1200 ? 4 : window.innerWidth >= 768 ? 3 : 2;
      const col = Math.max(0, Math.min(cols - 1, Math.floor((bRect.left - gRect.left) / (gRect.width / cols))));
      return col * 70;
    };

    const io = 'IntersectionObserver' in window
      ? new IntersectionObserver((entries) => {
          entries.forEach((entry) => {
            if (!entry.isIntersecting) return;
            io.unobserve(entry.target);
            entry.target.style.transitionDelay = getColDelay(entry.target) + 'ms';
            entry.target.classList.add('masonry-revealed');
          });
        }, { rootMargin: '0px 0px -30px 0px', threshold: 0.05 })
      : null;

    const observeVisible = () => {
      Array.from(grid.querySelectorAll('.inspire-moods-masonry__brick')).forEach((brick) => {
        if (io) io.unobserve(brick);
        brick.classList.remove('masonry-revealed');
        brick.style.transitionDelay = '';
        if (!brick.classList.contains('is-hidden')) {
          if (io) io.observe(brick);
          else brick.classList.add('masonry-revealed');
        }
      });
    };

    observeVisible();

    // ── Pagination transition ──
    const paginationNav = root.querySelector('[data-pagination]');
    if (paginationNav) {
      paginationNav.addEventListener('click', (e) => {
        if (!e.target.closest('button[data-page], [data-prev], [data-next]')) return;
        setTimeout(() => observeVisible(), 0);
      }, true);
    }

    // ── Lightbox ──
    const lightbox = root.querySelector('[data-inspire-moods-masonry-lightbox]');
    if (!lightbox) return;
    const lbImg = lightbox.querySelector('[data-inspire-moods-masonry-lightbox-img]');
    const lbCounter = lightbox.querySelector('[data-inspire-moods-masonry-lightbox-counter]');
    const lbCloseEls = lightbox.querySelectorAll('[data-inspire-moods-masonry-lightbox-close]');
    const lbPrev = lightbox.querySelector('[data-inspire-moods-masonry-lightbox-prev]');
    const lbNext = lightbox.querySelector('[data-inspire-moods-masonry-lightbox-next]');

    const visibleItems = () => Array.from(grid.querySelectorAll('[data-inspire-moods-masonry-item]')).filter(
      (el) => !el.closest('.inspire-moods-masonry__brick')?.classList.contains('is-hidden')
    );

    let current = -1;
    let lastFocus = null;

    const updateCounter = (items) => {
      if (lbCounter && items.length) lbCounter.textContent = `${current + 1} / ${items.length}`;
    };

    const showAt = (index) => {
      const items = visibleItems();
      if (!items.length) return;
      current = ((index % items.length) + items.length) % items.length;
      const item = items[current];
      if (lbImg) { lbImg.src = item.dataset.src || ''; lbImg.alt = item.dataset.alt || ''; }
      updateCounter(items);
    };

    const open = (index) => {
      lastFocus = document.activeElement;
      showAt(index);
      lightbox.classList.add('is-open');
      lightbox.setAttribute('aria-hidden', 'false');
      document.body.classList.add('inspire-moods-masonry-lightbox-locked');
      if (window.__lenis) window.__lenis.stop();
    };

    const close = () => {
      lightbox.classList.remove('is-open');
      lightbox.setAttribute('aria-hidden', 'true');
      document.body.classList.remove('inspire-moods-masonry-lightbox-locked');
      if (window.__lenis) window.__lenis.start();
      setTimeout(() => { if (!lightbox.classList.contains('is-open') && lbImg) lbImg.removeAttribute('src'); }, 500);
      if (lastFocus?.focus) lastFocus.focus();
    };

    grid.addEventListener('click', (e) => {
      const item = e.target.closest('[data-inspire-moods-masonry-item]');
      if (!item) return;
      const items = visibleItems();
      const idx = items.indexOf(item);
      if (idx >= 0) open(idx);
    });

    lbCloseEls.forEach((el) => el.addEventListener('click', close));
    lbPrev?.addEventListener('click', () => showAt(current - 1));
    lbNext?.addEventListener('click', () => showAt(current + 1));

    document.addEventListener('keydown', (e) => {
      if (!lightbox.classList.contains('is-open')) return;
      if (e.key === 'Escape') close();
      else if (e.key === 'ArrowLeft') showAt(current - 1);
      else if (e.key === 'ArrowRight') showAt(current + 1);
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["section-inspire-moods"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-moods]').forEach((section) => {
    const top = section.querySelector('[data-row-top]');
    const bottom = section.querySelector('[data-row-bottom]');
    if (!top || !bottom) return;

    const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (reduced) return;

    const distance = 140;

    let raf = null;
    const update = () => {
      raf = null;
      const rect = section.getBoundingClientRect();
      const vh = window.innerHeight;
      const total = vh + rect.height;
      if (total <= 0) return;
      const p = Math.max(0, Math.min(1, (vh - rect.top) / total));
      const t = p * 2 - 1;
      top.style.setProperty('--moods-x', `${-t * distance}px`);
      bottom.style.setProperty('--moods-x', `${t * distance}px`);
    };

    const onScroll = () => {
      if (!raf) raf = requestAnimationFrame(update);
    };

    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll, { passive: true });
    update();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["section-inspire-portfolio-grid"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-portfolio-section]').forEach((section) => {
    const grid = section.querySelector('[data-portfolio-grid]');
    const noResults = section.querySelector('[data-portfolio-no-results]');
    if (!grid) return;

    const itemsPerPage = parseInt(section.dataset.itemsPerPage || '12', 10);

    const openBtn = section.querySelector('[data-portfolio-filters-open]');
    const overlay = section.querySelector('[data-portfolio-filters-overlay]');
    const drawer = section.querySelector('[data-portfolio-filters-drawer]');
    const closeBtns = section.querySelectorAll('[data-portfolio-filters-close]');
    const clearBtn = section.querySelector('[data-portfolio-filters-clear]');
    const chipsMount = section.querySelector('[data-portfolio-chips-mount]');
    const inlineMount = section.querySelector('[data-portfolio-inline-chips]');
    const moodsGroup = section.querySelector('[data-portfolio-moods-group]');
    let chips = [];
    const cards = Array.from(grid.querySelectorAll('.portfolio-card-wrap'));
    const activeFiltersEl = section.querySelector('[data-portfolio-active-filters]');

    // ── Build filter chips from facet source ──
    const facetSource = document.getElementById('portfolio-facet-source');
    if (facetSource) {
      const moodsRaw = facetSource.dataset.facetMoods || '';
      const moodList = moodsRaw
        .split('||')
        .map((s) => s.trim())
        .filter(Boolean);

      const makeChip = (moodName) => {
        const btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'portfolio-chip';
        btn.setAttribute('data-portfolio-chip', '');
        btn.dataset.type = 'mood';
        btn.dataset.value = moodName;
        btn.textContent = moodName;
        return btn;
      };

      if (chipsMount) {
        chipsMount.innerHTML = '';
        moodList.forEach((m) => chipsMount.appendChild(makeChip(m)));
      }
      if (inlineMount) {
        inlineMount.innerHTML = '';
        moodList.forEach((m) => inlineMount.appendChild(makeChip(m)));
      }

      if (moodsGroup) moodsGroup.hidden = moodList.length === 0;
      if (openBtn) openBtn.hidden = moodList.length === 0;
      if (inlineMount) inlineMount.hidden = moodList.length === 0;
    }

    chips = Array.from(section.querySelectorAll('[data-portfolio-chip]'));

    let selectedMoods = new Set();
    let savedScrollY = 0;
    let isDrawerOpen = false;
    let prevScrollBehavior = '';

    // ── Body scroll lock ──
    const lockBody = () => {
      savedScrollY = window.scrollY;
      prevScrollBehavior = document.documentElement.style.scrollBehavior || '';
      document.documentElement.style.scrollBehavior = 'auto';
      document.body.style.cssText += ';position:fixed;top:-' + savedScrollY + 'px;left:0;right:0;width:100%';
    };
    const unlockBody = () => {
      document.body.style.position = '';
      document.body.style.top = '';
      document.body.style.left = '';
      document.body.style.right = '';
      document.body.style.width = '';
      window.scrollTo(0, savedScrollY);
      document.documentElement.style.scrollBehavior = prevScrollBehavior;
    };

    // ── Drawer ──
    const openDrawer = () => {
      if (!drawer || !overlay || isDrawerOpen) return;
      isDrawerOpen = true;
      drawer.hidden = false;
      overlay.hidden = false;
      lockBody();
      requestAnimationFrame(() => section.classList.add('portfolio-filters-open'));
    };
    const closeDrawer = () => {
      if (!drawer || !overlay || !isDrawerOpen) return;
      isDrawerOpen = false;
      section.classList.remove('portfolio-filters-open');
      setTimeout(() => {
        drawer.hidden = true;
        overlay.hidden = true;
        unlockBody();
      }, 260);
    };

    // ── Helpers ──
    const toList = (raw) =>
      (raw || '')
        .split('||')
        .map((s) => s.trim())
        .filter(Boolean);

    const syncChips = () => {
      chips.forEach((chip) => chip.classList.toggle('is-active', selectedMoods.has(chip.dataset.value)));
    };

    const syncActiveFilters = () => {
      if (!activeFiltersEl) return;
      const tags = [];
      selectedMoods.forEach((m) => tags.push({ label: m, type: 'mood', value: m }));
      if (tags.length === 0) {
        activeFiltersEl.hidden = true;
        activeFiltersEl.innerHTML = '';
        return;
      }
      activeFiltersEl.hidden = false;
      // Built with DOM APIs, never innerHTML: mood values can come from the URL.
      activeFiltersEl.replaceChildren(
        ...tags.map((t) => {
          const btn = document.createElement('button');
          btn.type = 'button';
          btn.className = 'portfolio-active-chip';
          btn.dataset.removeType = t.type;
          btn.dataset.removeValue = t.value;
          btn.append(t.label);
          btn.insertAdjacentHTML(
            'beforeend',
            '<svg viewBox="0 0 12 12" width="10" height="10" fill="none" aria-hidden="true"><path d="M2 2l8 8M10 2l-8 8" stroke="currentColor" stroke-width="1.6" stroke-linecap="round"/></svg>'
          );
          btn.addEventListener('click', () => {
            if (btn.dataset.removeType === 'mood') selectedMoods.delete(btn.dataset.removeValue);
            syncChips();
            onFilterChange();
          });
          return btn;
        })
      );
    };

    const cardMatches = (card) => {
      const moods = toList(card.dataset.moods);
      return selectedMoods.size === 0 || moods.some((m) => selectedMoods.has(m));
    };

    // ── Pagination state ──
    const pagNav = section.querySelector('[data-pagination]');
    const originalTotalPages = pagNav ? parseInt(pagNav.dataset.totalPages, 10) || 1 : 1;
    let currentTotalPages = originalTotalPages;
    let currentPage = 1;

    const setPageVisibility = (page) => {
      cards.forEach((card) => {
        card.classList.toggle('is-page-hidden', parseInt(card.dataset.page || '1', 10) !== page);
      });
    };

    const visiblePageSet = (cur, total) => {
      if (total <= 7) {
        const s = new Set();
        for (let i = 1; i <= total; i++) s.add(i);
        return s;
      }
      const s = new Set([1, total]);
      for (let i = Math.max(2, cur - 2); i <= Math.min(total - 1, cur + 2); i++) s.add(i);
      return s;
    };

    const renderPagNav = (page, pages) => {
      if (!pagNav) return;
      pagNav.hidden = pages <= 1;

      const prevBtn = pagNav.querySelector('[data-prev]');
      const nextBtn = pagNav.querySelector('[data-next]');
      if (prevBtn) prevBtn.disabled = page === 1;
      if (nextBtn) nextBtn.disabled = page === pages;

      const pageButtons = Array.from(pagNav.querySelectorAll('button.collections-pagination-page'));
      pageButtons.forEach((btn) => {
        const p = parseInt(btn.dataset.page, 10);
        const active = p === page;
        btn.classList.toggle('is-current', active);
        if (active) btn.setAttribute('aria-current', 'page');
        else btn.removeAttribute('aria-current');
      });

      const pageSlots = Array.from(pagNav.querySelectorAll('[data-page-slot]'));
      const visible = visiblePageSet(page, pages);
      pageSlots.forEach((slot) => {
        const p = parseInt(slot.dataset.pageSlot, 10);
        slot.hidden = p > pages || !visible.has(p);
      });

      const ellipsisBefore = pagNav.querySelector('[data-ellipsis-before]');
      const ellipsisAfter = pagNav.querySelector('[data-ellipsis-after]');
      if (pages > 2) {
        const sorted = Array.from(visible).sort((a, b) => a - b);
        if (ellipsisBefore) ellipsisBefore.hidden = sorted[1] <= 2;
        if (ellipsisAfter) ellipsisAfter.hidden = sorted[sorted.length - 2] >= pages - 1;
      } else {
        if (ellipsisBefore) ellipsisBefore.hidden = true;
        if (ellipsisAfter) ellipsisAfter.hidden = true;
      }
    };

    const updatePageUrl = (page) => {
      const url = new URL(window.location.href);
      if (page === 1) url.searchParams.delete('pag');
      else url.searchParams.set('pag', String(page));
      history.replaceState({}, '', url.toString());
    };

    const animateCardsIn = () => {
      const entering = cards.filter(
        (c) => !c.classList.contains('is-page-hidden') && !c.classList.contains('is-filter-hidden')
      );
      entering.forEach((card, i) => {
        card.style.animation = 'none';
        void card.offsetWidth;
        card.style.animation = `portfolio-card-enter 0.5s cubic-bezier(0.22,1,0.36,1) ${i * 55}ms both`;
      });
      const cleanupMs = 500 + Math.max(0, entering.length - 1) * 55 + 150;
      setTimeout(() => entering.forEach((c) => (c.style.animation = '')), cleanupMs);
    };

    // ── Core: apply filters + re-paginate ──
    const applyFilters = () => {
      const hasFilters = selectedMoods.size > 0;

      if (!hasFilters) {
        cards.forEach((c) => c.classList.remove('is-filter-hidden'));
        setPageVisibility(currentPage);
        currentTotalPages = originalTotalPages;
      } else {
        const matching = cards.filter(cardMatches);
        currentTotalPages = Math.max(1, Math.ceil(matching.length / itemsPerPage));
        if (currentPage > currentTotalPages) currentPage = 1;
        const pageStart = (currentPage - 1) * itemsPerPage;
        const pageEnd = pageStart + itemsPerPage;
        cards.forEach((card) => {
          const idx = matching.indexOf(card);
          card.classList.remove('is-page-hidden');
          card.classList.toggle('is-filter-hidden', idx < pageStart || idx >= pageEnd);
        });
      }

      renderPagNav(currentPage, currentTotalPages);
      if (noResults)
        noResults.hidden = cards.some(
          (c) => !c.classList.contains('is-page-hidden') && !c.classList.contains('is-filter-hidden')
        );
      syncActiveFilters();
    };

    const saveFiltersToUrl = () => {
      const url = new URL(window.location.href);
      url.searchParams.delete('mood');
      selectedMoods.forEach((m) => url.searchParams.append('mood', m));
      history.replaceState({}, '', url.toString());
      const data = { moods: Array.from(selectedMoods) };
      if (data.moods.length) sessionStorage.setItem('portfolio_filters', JSON.stringify(data));
      else sessionStorage.removeItem('portfolio_filters');
    };

    const onFilterChange = () => {
      currentPage = 1;
      updatePageUrl(1);
      syncChips();
      applyFilters();
      saveFiltersToUrl();
    };

    // ── Drawer events ──
    openBtn?.addEventListener('click', openDrawer);
    overlay?.addEventListener('click', closeDrawer);
    overlay?.addEventListener('touchmove', (e) => e.preventDefault(), { passive: false });
    closeBtns.forEach((b) => b.addEventListener('click', closeDrawer));
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape') closeDrawer();
    });

    chips.forEach((chip) => {
      chip.addEventListener('click', () => {
        const { value } = chip.dataset;
        if (!value) return;
        if (selectedMoods.has(value)) selectedMoods.delete(value);
        else selectedMoods.add(value);
        onFilterChange();
      });
    });

    clearBtn?.addEventListener('click', () => {
      selectedMoods = new Set();
      onFilterChange();
    });

    // ── View toggle ──
    const viewBtns = Array.from(section.querySelectorAll('[data-portfolio-view]'));
    const setView = (view) => {
      viewBtns.forEach((b) => {
        const active = b.dataset.portfolioView === view;
        b.classList.toggle('is-active', active);
        b.setAttribute('aria-pressed', active ? 'true' : 'false');
      });
      grid.classList.toggle('portfolio-grid--list', view === 'list');
      const url = new URL(window.location.href);
      if (view === 'list') url.searchParams.set('pview', 'list');
      else url.searchParams.delete('pview');
      history.replaceState({}, '', url.toString());
    };
    setView(new URL(window.location.href).searchParams.get('pview') === 'list' ? 'list' : 'grid');
    viewBtns.forEach((btn) => btn.addEventListener('click', () => setView(btn.dataset.portfolioView)));

    // ── Pagination click handling ──
    if (pagNav) {
      const EXIT_MS = 210;

      const goToPage = (page) => {
        page = Math.max(1, Math.min(currentTotalPages, page));
        if (page === currentPage) return;
        const prevBtn = pagNav.querySelector('[data-prev]');
        const nextBtn = pagNav.querySelector('[data-next]');
        if (prevBtn) prevBtn.disabled = true;
        if (nextBtn) nextBtn.disabled = true;
        grid.classList.add('is-pag-exiting');
        setTimeout(() => {
          currentPage = page;
          applyFilters();
          updatePageUrl(page);
          grid.classList.remove('is-pag-exiting');
          animateCardsIn();
        }, EXIT_MS);
      };

      pagNav.addEventListener('click', (e) => {
        const pageBtn = e.target.closest('button.collections-pagination-page[data-page]');
        if (pageBtn) {
          const target = parseInt(pageBtn.dataset.page, 10);
          if (target !== currentPage) goToPage(target);
          return;
        }
        if (e.target.closest('[data-prev]')) { goToPage(currentPage - 1); return; }
        if (e.target.closest('[data-next]')) goToPage(currentPage + 1);
      });
    }

    // ── Init: restore page + filters from URL ──
    const initUrl = new URL(window.location.href);
    const urlPage = parseInt(initUrl.searchParams.get('pag') || '1', 10);
    currentPage = urlPage >= 1 ? urlPage : 1;

    // Only accept moods that exist as a chip; anything else in the URL is ignored.
    const knownMoods = new Set(chips.map((c) => c.dataset.value));
    initUrl.searchParams.getAll('mood').forEach((m) => {
      if (knownMoods.has(m)) selectedMoods.add(m);
    });

    syncChips();
    saveFiltersToUrl();
    applyFilters();
    if (currentPage !== 1) animateCardsIn();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["section-inspire-project-detail"] && !Shopify.designMode) return;
  try {
    
  // Restore portfolio breadcrumb link with any saved filter state
  try {
    const saved = sessionStorage.getItem('portfolio_filters');
    if (saved) {
      const { moods = [] } = JSON.parse(saved);
      if (moods.length) {
        document.querySelectorAll('a[href*="portfolio"]').forEach((link) => {
          const url = new URL(link.href, window.location.origin);
          url.searchParams.delete('mood');
          moods.forEach((m) => url.searchParams.append('mood', m));
          link.href = url.toString();
        });
      }
    }
  } catch (e) {}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["section-inspire-project-gallery"]) return;
  try {
    
  const lightbox = document.querySelector('[data-project-lightbox]');
  const grid = document.querySelector('[data-project-gallery-grid]');

  if (lightbox && grid) {
    const lbImg = lightbox.querySelector('[data-project-lightbox-img]');
    const lbCounter = lightbox.querySelector('[data-project-lightbox-counter]');
    const lbCloseEls = lightbox.querySelectorAll('[data-project-lightbox-close]');
    const lbPrev = lightbox.querySelector('[data-project-lightbox-prev]');
    const lbNext = lightbox.querySelector('[data-project-lightbox-next]');

    const items = Array.from(grid.querySelectorAll('[data-project-gallery-item]'));
    let current = -1;
    let lastFocus = null;

    const updateCounter = () => {
      if (lbCounter && items.length) lbCounter.textContent = `${current + 1} / ${items.length}`;
    };

    const showAt = (index) => {
      if (!items.length) return;
      current = ((index % items.length) + items.length) % items.length;
      const item = items[current];
      const src = item.dataset.src || '';
      if (src) lbImg.src = src;
      lbImg.alt = item.dataset.alt || '';
      updateCounter();
    };

    const open = (index) => {
      lastFocus = document.activeElement;
      showAt(index);
      lightbox.classList.add('is-open');
      lightbox.setAttribute('aria-hidden', 'false');
      document.body.classList.add('project-lightbox-locked');
      if (window.__lenis) window.__lenis.stop();
    };

    const close = () => {
      lightbox.classList.remove('is-open');
      lightbox.setAttribute('aria-hidden', 'true');
      document.body.classList.remove('project-lightbox-locked');
      if (window.__lenis) window.__lenis.start();
      setTimeout(() => {
        if (!lightbox.classList.contains('is-open')) lbImg.removeAttribute('src');
      }, 500);
      if (lastFocus && typeof lastFocus.focus === 'function') lastFocus.focus();
    };

    grid.addEventListener('click', (e) => {
      const item = e.target.closest('[data-project-gallery-item]');
      if (!item) return;
      const idx = items.indexOf(item);
      if (idx >= 0) open(idx);
    });

    lbCloseEls.forEach((el) => el.addEventListener('click', close));
    lbPrev?.addEventListener('click', () => showAt(current - 1));
    lbNext?.addEventListener('click', () => showAt(current + 1));

    document.addEventListener('keydown', (e) => {
      if (!lightbox.classList.contains('is-open')) return;
      if (e.key === 'Escape') close();
      else if (e.key === 'ArrowLeft') showAt(current - 1);
      else if (e.key === 'ArrowRight') showAt(current + 1);
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["section-inspire-showroom-detail"] && !Shopify.designMode) return;
  try {
    
  // Restore portfolio breadcrumb link with any saved filter state
  try {
    const saved = sessionStorage.getItem('portfolio_filters');
    if (saved) {
      const { moods = [] } = JSON.parse(saved);
      if (moods.length) {
        document.querySelectorAll('a[href*="portfolio"]').forEach((link) => {
          const url = new URL(link.href, window.location.origin);
          url.searchParams.delete('mood');
          moods.forEach((m) => url.searchParams.append('mood', m));
          link.href = url.toString();
        });
      }
    }
  } catch (e) {}

  const lightbox = document.querySelector('[data-project-lightbox]');
  const grid = document.querySelector('[data-project-gallery-grid]');

  if (lightbox && grid) {
    const lbImg = lightbox.querySelector('[data-project-lightbox-img]');
    const lbCounter = lightbox.querySelector('[data-project-lightbox-counter]');
    const lbCloseEls = lightbox.querySelectorAll('[data-project-lightbox-close]');
    const lbPrev = lightbox.querySelector('[data-project-lightbox-prev]');
    const lbNext = lightbox.querySelector('[data-project-lightbox-next]');

    const items = Array.from(grid.querySelectorAll('[data-project-gallery-item]'));
    let current = -1;
    let lastFocus = null;

    const updateCounter = () => {
      if (lbCounter && items.length) lbCounter.textContent = `${current + 1} / ${items.length}`;
    };

    const showAt = (index) => {
      if (!items.length) return;
      current = ((index % items.length) + items.length) % items.length;
      const item = items[current];
      const src = item.dataset.src || '';
      if (src) lbImg.src = src;
      lbImg.alt = item.dataset.alt || '';
      updateCounter();
    };

    const open = (index) => {
      lastFocus = document.activeElement;
      showAt(index);
      lightbox.classList.add('is-open');
      lightbox.setAttribute('aria-hidden', 'false');
      document.body.classList.add('project-lightbox-locked');
      if (window.__lenis) window.__lenis.stop();
    };

    const close = () => {
      lightbox.classList.remove('is-open');
      lightbox.setAttribute('aria-hidden', 'true');
      document.body.classList.remove('project-lightbox-locked');
      if (window.__lenis) window.__lenis.start();
      setTimeout(() => {
        if (!lightbox.classList.contains('is-open')) lbImg.removeAttribute('src');
      }, 500);
      if (lastFocus && typeof lastFocus.focus === 'function') lastFocus.focus();
    };

    grid.addEventListener('click', (e) => {
      const item = e.target.closest('[data-project-gallery-item]');
      if (!item) return;
      const idx = items.indexOf(item);
      if (idx >= 0) open(idx);
    });

    lbCloseEls.forEach((el) => el.addEventListener('click', close));
    lbPrev?.addEventListener('click', () => showAt(current - 1));
    lbNext?.addEventListener('click', () => showAt(current + 1));

    document.addEventListener('keydown', (e) => {
      if (!lightbox.classList.contains('is-open')) return;
      if (e.key === 'Escape') close();
      else if (e.key === 'ArrowLeft') showAt(current - 1);
      else if (e.key === 'ArrowRight') showAt(current + 1);
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["section-inspire-showroom-gallery"] && !Shopify.designMode) return;
  try {
    
  const lightbox = document.querySelector('[data-showroom-lightbox]');
  const grid = document.querySelector('[data-showroom-gallery-grid]');

  if (lightbox && grid) {
    const lbImg = lightbox.querySelector('[data-showroom-lightbox-img]');
    const lbCounter = lightbox.querySelector('[data-showroom-lightbox-counter]');
    const lbCloseEls = lightbox.querySelectorAll('[data-showroom-lightbox-close]');
    const lbPrev = lightbox.querySelector('[data-showroom-lightbox-prev]');
    const lbNext = lightbox.querySelector('[data-showroom-lightbox-next]');

    const items = Array.from(grid.querySelectorAll('[data-showroom-gallery-item]'));
    let current = -1;
    let lastFocus = null;

    const updateCounter = () => {
      if (lbCounter && items.length) lbCounter.textContent = `${current + 1} / ${items.length}`;
    };

    const showAt = (index) => {
      if (!items.length) return;
      current = ((index % items.length) + items.length) % items.length;
      const item = items[current];
      if (lbImg) { lbImg.src = item.dataset.src || ''; lbImg.alt = item.dataset.alt || ''; }
      updateCounter();
    };

    const open = (index) => {
      lastFocus = document.activeElement;
      showAt(index);
      lightbox.classList.add('is-open');
      lightbox.setAttribute('aria-hidden', 'false');
      document.body.classList.add('showroom-lightbox-locked');
      if (window.__lenis) window.__lenis.stop();
    };

    const close = () => {
      lightbox.classList.remove('is-open');
      lightbox.setAttribute('aria-hidden', 'true');
      document.body.classList.remove('showroom-lightbox-locked');
      if (window.__lenis) window.__lenis.start();
      setTimeout(() => { if (!lightbox.classList.contains('is-open') && lbImg) lbImg.removeAttribute('src'); }, 500);
      if (lastFocus?.focus) lastFocus.focus();
    };

    grid.addEventListener('click', (e) => {
      const item = e.target.closest('[data-showroom-gallery-item]');
      if (!item) return;
      const idx = items.indexOf(item);
      if (idx >= 0) open(idx);
    });

    lbCloseEls.forEach((el) => el.addEventListener('click', close));
    lbPrev?.addEventListener('click', () => showAt(current - 1));
    lbNext?.addEventListener('click', () => showAt(current + 1));

    document.addEventListener('keydown', (e) => {
      if (!lightbox.classList.contains('is-open')) return;
      if (e.key === 'Escape') close();
      else if (e.key === 'ArrowLeft') showAt(current - 1);
      else if (e.key === 'ArrowRight') showAt(current + 1);
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["section-inspire-showroom-page-gallery"] && !Shopify.designMode) return;
  try {
    
  const pgLightbox = document.querySelector('[data-showroom-page-lightbox]');
  const pgGrid    = document.querySelector('[data-showroom-page-gallery-grid]');

  if (pgLightbox && pgGrid) {
    const lbImg     = pgLightbox.querySelector('[data-showroom-page-lightbox-img]');
    const lbCounter = pgLightbox.querySelector('[data-showroom-page-lightbox-counter]');
    const lbCloses  = pgLightbox.querySelectorAll('[data-showroom-page-lightbox-close]');
    const lbPrev    = pgLightbox.querySelector('[data-showroom-page-lightbox-prev]');
    const lbNext    = pgLightbox.querySelector('[data-showroom-page-lightbox-next]');

    const items = Array.from(pgGrid.querySelectorAll('[data-showroom-page-gallery-item]'));
    let current = -1;
    let lastFocus = null;

    const updateCounter = () => {
      if (lbCounter) lbCounter.textContent = `${current + 1} / ${items.length}`;
    };

    const showAt = (index) => {
      if (!items.length) return;
      current = ((index % items.length) + items.length) % items.length;
      if (lbImg) { lbImg.src = items[current].dataset.src || ''; lbImg.alt = items[current].dataset.alt || ''; }
      updateCounter();
    };

    const open = (index) => {
      lastFocus = document.activeElement;
      showAt(index);
      pgLightbox.classList.add('is-open');
      pgLightbox.setAttribute('aria-hidden', 'false');
      document.body.classList.add('showroom-page-lightbox-locked');
      if (window.__lenis) window.__lenis.stop();
    };

    const close = () => {
      pgLightbox.classList.remove('is-open');
      pgLightbox.setAttribute('aria-hidden', 'true');
      document.body.classList.remove('showroom-page-lightbox-locked');
      if (window.__lenis) window.__lenis.start();
      setTimeout(() => { if (!pgLightbox.classList.contains('is-open') && lbImg) lbImg.removeAttribute('src'); }, 500);
      if (lastFocus?.focus) lastFocus.focus();
    };

    pgGrid.addEventListener('click', (e) => {
      const item = e.target.closest('[data-showroom-page-gallery-item]');
      if (!item) return;
      open(items.indexOf(item));
    });

    lbCloses.forEach((el) => el.addEventListener('click', close));
    lbPrev?.addEventListener('click', () => showAt(current - 1));
    lbNext?.addEventListener('click', () => showAt(current + 1));

    document.addEventListener('keydown', (e) => {
      if (!pgLightbox.classList.contains('is-open')) return;
      if (e.key === 'Escape') close();
      else if (e.key === 'ArrowLeft') showAt(current - 1);
      else if (e.key === 'ArrowRight') showAt(current + 1);
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["section-inspire-showroom-page-hours"] && !Shopify.designMode) return;
  try {
    
  (function () {
    const list = document.querySelector('[data-showroom-hours-list]');
    if (!list) return;

    const axisStart = parseInt(list.dataset.axisStart, 10);
    const axisEnd = parseInt(list.dataset.axisEnd, 10);
    const axisRange = axisEnd - axisStart;

    const dayMap = {
      0: ['zo', 'sun', 'zondag', 'sunday'],
      1: ['ma', 'mon', 'maandag', 'monday'],
      2: ['di', 'tue', 'dinsdag', 'tuesday'],
      3: ['wo', 'wed', 'woensdag', 'wednesday'],
      4: ['do', 'thu', 'donderdag', 'thursday'],
      5: ['vr', 'fri', 'vrijdag', 'friday'],
      6: ['za', 'sat', 'zaterdag', 'saturday'],
    };

    const now = new Date();
    const today = now.getDay();
    const nowMins = now.getHours() * 60 + now.getMinutes();

    let isOpenNow = false;

    list.querySelectorAll('[data-showroom-hours-row]').forEach((row) => {
      const dayText = (row.querySelector('.showroom-hours-day')?.textContent || '').toLowerCase().trim();
      const isToday = dayMap[today]?.some((k) => dayText.startsWith(k));
      if (!isToday) return;

      row.classList.add('is-today');

      const closed = row.dataset.closed === 'true';
      if (!closed) {
        const parseTime = (str) => {
          const [h, m] = (str || '').split(':').map(Number);
          return h * 60 + (m || 0);
        };
        const openMins = parseTime(row.dataset.open);
        const closeMins = parseTime(row.dataset.close);

        isOpenNow = nowMins >= openMins && nowMins < closeMins;

        const nowLine = row.querySelector('[data-now-line]');
        if (nowLine && nowMins >= axisStart && nowMins <= axisEnd) {
          const pct = ((nowMins - axisStart) / axisRange) * 100;
          nowLine.style.left = pct + '%';
          nowLine.classList.add('is-visible');
        }
      }
    });

    const statusBlock = document.querySelector('[data-showroom-status-block]');
    const statusDot = document.querySelector('[data-showroom-status-dot]');
    const statusText = document.querySelector('[data-showroom-status-text]');

    if (statusBlock && statusText) {
      statusBlock.classList.add(isOpenNow ? 'is-open' : 'is-closed');
      statusText.textContent = isOpenNow ? 'Nu open' : 'Nu gesloten';
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["section-inspire-showroom-page-schedule"] && !Shopify.designMode) return;
  try {
    
  (function () {
    const today = new Date().getDay();
    document.querySelectorAll('[data-schedule-day]').forEach((row) => {
      if (parseInt(row.dataset.scheduleDay, 10) === today) {
        row.classList.add('is-today');
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["section-logo-marquee"] && !Shopify.designMode) return;
  try {
    
  function initMarquee(wrapper) {
    var track = wrapper.querySelector('.marquee-track');
    if (!track) return;
    var check = function () {
      track.classList.remove('marquee-track--centered');
      var setWidth = track.scrollWidth / 2;
      if (setWidth > 0 && setWidth <= wrapper.clientWidth) {
        track.classList.add('marquee-track--centered');
      }
    };
    check();
    window.addEventListener('resize', check);
    window.addEventListener('load', check);
    track.querySelectorAll('img').forEach(function (img) {
      if (img.complete) return;
      img.addEventListener('load', check, { once: true });
      img.addEventListener('error', check, { once: true });
    });
  }
  document.querySelectorAll('.marquee-wrapper').forEach(initMarquee);
  document.addEventListener('shopify:section:load', function (e) {
    e.target.querySelectorAll('.marquee-wrapper').forEach(initMarquee);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["section-medewerker-detail"]) return;
  try {
    
  document.querySelectorAll('.mwk-articles [data-card-href]').forEach(function (card) {
    card.addEventListener('click', function (e) {
      if (!e.target.closest('a')) window.location.href = card.dataset.cardHref;
    });
    card.addEventListener('keydown', function (e) {
      if ((e.key === 'Enter' || e.key === ' ') && !e.target.closest('a')) {
        e.preventDefault();
        window.location.href = card.dataset.cardHref;
      }
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["section-page-about"] && !Shopify.designMode) return;
  try {
    
  (function () {
    /* Items are only hidden once this runs (html.ao-tl-reveal), so they stay
       visible without IntersectionObserver, with reduced motion, and after a
       theme-editor re-render (which re-runs init via shopify:section:load). */
    if (!window.IntersectionObserver) return;
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

    function init(scope) {
      var items = scope.querySelectorAll('[data-ao-tl-item]:not(.is-visible)');
      if (!items.length) return;
      document.documentElement.classList.add('ao-tl-reveal');

      var io = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting) {
              entry.target.classList.add('is-visible');
              io.unobserve(entry.target);
            }
          });
        },
        { threshold: 0.12, rootMargin: '0px 0px -48px 0px' }
      );

      items.forEach(function (item, i) {
        item.style.transitionDelay = i * 0.1 + 's';
        io.observe(item);
      });
    }

    init(document);
    document.addEventListener('shopify:section:load', function (e) { init(e.target); });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["section-pdp-media"] && !Shopify.designMode) return;
  try {
    
  // Cover-button → reveal & play. Works for both the uploaded file
  // (<video data-video-file>) and YouTube iframe fallback.
  document.querySelectorAll('[data-video-frame]').forEach((frame) => {
    const cover = frame.querySelector('[data-video-cover]');
    if (!cover) return;
    const iframe = frame.querySelector('[data-video-iframe]');
    const file = frame.querySelector('[data-video-file]');

    cover.addEventListener('click', () => {
      frame.classList.add('is-active');
      if (file) {
        try { file.play(); } catch (_) {}
      } else if (iframe) {
        try {
          iframe.contentWindow.postMessage(
            '{"event":"command","func":"playVideo","args":""}',
            '*'
          );
        } catch (_) {}
      }
    });
  });

  const lightbox = document.querySelector('.pdp-media-lightbox');
  if (lightbox) {
    const lbImg = lightbox.querySelector('[data-lightbox-img]');
    const lbCounter = lightbox.querySelector('[data-lightbox-counter]');
    const lbCloseEls = lightbox.querySelectorAll('[data-lightbox-close]');
    const lbPrev = lightbox.querySelector('[data-lightbox-prev]');
    const lbNext = lightbox.querySelector('[data-lightbox-next]');

    let items = [];
    let current = -1;
    let lastFocus = null;

    const refreshItems = (sourceGrid) => {
      items = Array.from(sourceGrid.querySelectorAll('[data-media-item]'));
    };

    const updateCounter = () => {
      if (lbCounter && items.length) {
        lbCounter.textContent = `${current + 1} / ${items.length}`;
      }
    };

    const showAt = (index) => {
      if (!items.length) return;
      current = ((index % items.length) + items.length) % items.length;
      const item = items[current];
      const src = item.dataset.src;
      const alt = item.dataset.alt || '';
      lbImg.src = src;
      lbImg.alt = alt;
      updateCounter();
    };

    const open = (index) => {
      lastFocus = document.activeElement;
      showAt(index);
      lightbox.classList.add('is-open');
      lightbox.setAttribute('aria-hidden', 'false');
      document.body.classList.add('pdp-media-lightbox-locked');
      if (window.__lenis) window.__lenis.stop();
    };

    const close = () => {
      lightbox.classList.remove('is-open');
      lightbox.setAttribute('aria-hidden', 'true');
      document.body.classList.remove('pdp-media-lightbox-locked');
      if (window.__lenis) window.__lenis.start();
      setTimeout(() => {
        if (!lightbox.classList.contains('is-open')) {
          lbImg.src = '';
        }
      }, 500);
      if (lastFocus && typeof lastFocus.focus === 'function') lastFocus.focus();
    };

    document.querySelectorAll('.pdp-media-grid').forEach((grid) => {
      grid.addEventListener('click', (e) => {
        const item = e.target.closest('[data-media-item]');
        if (!item) return;
        refreshItems(grid);
        const idx = items.indexOf(item);
        if (idx >= 0) open(idx);
      });
    });

    lbCloseEls.forEach((el) => el.addEventListener('click', close));
    lbPrev?.addEventListener('click', () => showAt(current - 1));
    lbNext?.addEventListener('click', () => showAt(current + 1));

    document.addEventListener('keydown', (e) => {
      if (!lightbox.classList.contains('is-open')) return;
      if (e.key === 'Escape') close();
      else if (e.key === 'ArrowLeft') showAt(current - 1);
      else if (e.key === 'ArrowRight') showAt(current + 1);
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["section-reviews"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-reviews]').forEach((root) => {
    const slider = root.querySelector('[data-slider]');
    const prevBtns = root.querySelectorAll('[data-slider-prev]');
    const nextBtns = root.querySelectorAll('[data-slider-next]');
    const dotsEls = root.querySelectorAll('[data-slider-dots]');
    if (!slider) return;

    const total = slider.children.length;
    const dotGroups = [];
    dotsEls.forEach((container) => {
      const group = [];
      for (let i = 0; i < total; i++) {
        const d = document.createElement('button');
        d.type = 'button';
        d.className = 'reviews-slider-dot';
        d.setAttribute('aria-label', `Go to review ${i + 1}`);
        d.addEventListener('click', () => {
          const first = slider.firstElementChild;
          const w = first ? first.getBoundingClientRect().width : slider.clientWidth;
          slider.scrollTo({ left: i * w, behavior: 'smooth' });
        });
        container.appendChild(d);
        group.push(d);
      }
      dotGroups.push(group);
    });

    const stepWidth = () => {
      const first = slider.firstElementChild;
      return first ? first.getBoundingClientRect().width : slider.clientWidth;
    };

    let rafId = null;
    const update = () => {
      if (rafId) return;
      rafId = requestAnimationFrame(() => {
        const w = stepWidth();
        const idx = w > 0 ? Math.round(slider.scrollLeft / w) : 0;
        const max = slider.scrollWidth - slider.clientWidth;
        prevBtns.forEach((b) => (b.disabled = slider.scrollLeft <= 2));
        nextBtns.forEach((b) => (b.disabled = slider.scrollLeft >= max - 2));
        dotGroups.forEach((group) => {
          group.forEach((d, i) => d.classList.toggle('is-active', i === idx));
        });
        rafId = null;
      });
    };

    prevBtns.forEach((b) =>
      b.addEventListener('click', () => {
        slider.scrollBy({ left: -stepWidth(), behavior: 'smooth' });
      })
    );
    nextBtns.forEach((b) =>
      b.addEventListener('click', () => {
        slider.scrollBy({ left: stepWidth(), behavior: 'smooth' });
      })
    );

    slider.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update, { passive: true });
    requestAnimationFrame(update);

    // ── Read-more on mobile (CSS handles 2-line clamp; JS shows button + toggles class) ──
    root.querySelectorAll('[data-review-quote]').forEach((quote) => {
      const btn = quote.nextElementSibling;
      if (!btn || !btn.matches('[data-review-quote-toggle]')) return;
      const label = btn.querySelector('[data-toggle-label]');

      const setup = () => {
        if (window.innerWidth >= 768) {
          quote.classList.remove('is-expanded');
          btn.hidden = true;
          btn.setAttribute('aria-expanded', 'false');
          if (label) label.textContent = label.dataset.labelMore || label.textContent;
          return;
        }
        // Show button only when content actually overflows 2 lines
        quote.classList.remove('is-expanded');
        btn.hidden = quote.scrollHeight <= quote.clientHeight + 4;
      };

      btn.addEventListener('click', () => {
        const expanded = btn.getAttribute('aria-expanded') === 'true';
        quote.classList.toggle('is-expanded', !expanded);
        btn.setAttribute('aria-expanded', String(!expanded));
        if (label) label.textContent = (expanded ? label.dataset.labelMore : label.dataset.labelLess) || label.textContent;
      });

      setup();
      window.addEventListener('resize', setup, { passive: true });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["section-shop-bestsellers"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-bestsellers]').forEach((section) => {
    const track = section.querySelector('.bestsellers-track');
    if (!track) return;

    const isBelowLg = () => window.matchMedia('(max-width: 1023px)').matches;
    const reducedMotion = () => window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    const clamp = (v, min = 0, max = 1) => Math.max(min, Math.min(max, v));
    const ease = (t) => 1 - Math.pow(1 - t, 3);

    const setVar = (name, value) => section.style.setProperty(name, value.toFixed(4));

    let raf = null;
    const update = () => {
      raf = null;

      if (isBelowLg() || reducedMotion()) {
        // Reset all progress vars so static fallback applies
        [
          '--bs-title-p',
          '--bs-main-p',
          '--bs-subheader-p',
          '--bs-sat-1-p',
          '--bs-sat-2-p',
          '--bs-sat-3-p',
          '--bs-sat-4-p',
          '--bs-info-p',
        ].forEach((v) => {
          section.style.removeProperty(v);
        });
        return;
      }

      const rect = track.getBoundingClientRect();
      const vh = window.innerHeight || document.documentElement.clientHeight;
      const totalScroll = Math.max(1, rect.height - vh);
      const p = clamp(-rect.top / totalScroll);

      // Sub-progresses with easing
      const titleP = ease(clamp(p / 0.45));
      const mainP = ease(clamp(p / 0.55));
      const subheaderP = clamp(p / 0.3);

      const sat1P = ease(clamp((p - 0.35) / 0.3));
      const sat2P = ease(clamp((p - 0.45) / 0.3));
      const sat3P = ease(clamp((p - 0.4) / 0.3));
      const sat4P = ease(clamp((p - 0.5) / 0.3));

      const infoP = ease(clamp((p - 0.6) / 0.3));

      setVar('--bs-title-p', titleP);
      setVar('--bs-main-p', mainP);
      setVar('--bs-subheader-p', subheaderP);
      setVar('--bs-sat-1-p', sat1P);
      setVar('--bs-sat-2-p', sat2P);
      setVar('--bs-sat-3-p', sat3P);
      setVar('--bs-sat-4-p', sat4P);
      setVar('--bs-info-p', infoP);

      section.classList.toggle('is-final', titleP > 0.85);
    };

    const onScroll = () => {
      if (raf) return;
      raf = requestAnimationFrame(update);
    };

    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll, { passive: true });
    update();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["section-shop-featured"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-featured-section]').forEach((root) => {
    const slider = root.querySelector('[data-slider]');
    const prevBtn = root.querySelector('[data-slider-prev]');
    const nextBtn = root.querySelector('[data-slider-next]');
    const progressBar = root.querySelector('[data-progress]');
    const currentEl = root.querySelector('[data-slider-current]');
    const totalEl = root.querySelector('[data-slider-total]');

    if (!slider) return;

    const pad = (n) => String(n).padStart(2, '0');
    const originals = Array.from(slider.children);
    const baseCount = originals.length;
    if (totalEl) totalEl.textContent = pad(baseCount || 1);
    if (baseCount === 0) return;

    // Clone for infinite loop: prepend reversed + append in order → 3x content
    originals
      .slice()
      .reverse()
      .forEach((n) => {
        const c = n.cloneNode(true);
        c.setAttribute('aria-hidden', 'true');
        c.dataset.clone = 'start';
        slider.insertBefore(c, slider.firstChild);
      });
    originals.forEach((n) => {
      const c = n.cloneNode(true);
      c.setAttribute('aria-hidden', 'true');
      c.dataset.clone = 'end';
      slider.appendChild(c);
    });

    const stepSize = () => {
      const card = slider.querySelector(':scope > *');
      if (!card) return 0;
      const gap = parseFloat(getComputedStyle(slider).gap) || 0;
      return card.offsetWidth + gap;
    };

    const sectionWidth = () => slider.scrollWidth / 3;

    const setScroll = (x, instant = false) => {
      if (instant) {
        const prev = slider.style.scrollBehavior;
        const prevBar = progressBar ? progressBar.style.transition : '';
        slider.style.scrollBehavior = 'auto';
        if (progressBar) progressBar.style.transition = 'none';
        slider.scrollLeft = x;
        requestAnimationFrame(() => {
          slider.style.scrollBehavior = prev;
          if (progressBar) progressBar.style.transition = prevBar;
        });
      } else {
        slider.scrollLeft = x;
      }
    };

    // Center to middle section after first layout
    const recenter = () => {
      setScroll(sectionWidth(), true);
    };
    requestAnimationFrame(recenter);

    let rafId = null;
    const update = () => {
      if (rafId) return;
      rafId = requestAnimationFrame(() => {
        const w = sectionWidth();
        const rel = w > 0 ? (((slider.scrollLeft - w) % w) + w) % w : 0;
        const pct = w > 0 ? (rel / w) * 100 : 0;
        if (progressBar) progressBar.style.width = pct + '%';
        if (currentEl && baseCount > 0) {
          const step = stepSize();
          const idx = step > 0 ? (((Math.round(rel / step) % baseCount) + baseCount) % baseCount) + 1 : 1;
          currentEl.textContent = pad(idx);
        }
        rafId = null;
      });
    };

    // Teleport when scroll settles outside the middle section
    let settleTimer = null;
    const onScroll = () => {
      update();
      if (settleTimer) clearTimeout(settleTimer);
      settleTimer = setTimeout(() => {
        const w = sectionWidth();
        const s = slider.scrollLeft;
        if (s < w * 0.5) setScroll(s + w, true);
        else if (s > w * 1.5) setScroll(s - w, true);
      }, 90);
    };

    prevBtn?.addEventListener('click', () => {
      slider.scrollBy({ left: -stepSize(), behavior: 'smooth' });
    });
    nextBtn?.addEventListener('click', () => {
      slider.scrollBy({ left: stepSize(), behavior: 'smooth' });
    });

    slider.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener(
      'resize',
      () => {
        recenter();
        update();
      },
      { passive: true }
    );
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["section-shop-hero"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('.shop-hero-root').forEach((root) => {
    const slides = Array.from(root.querySelectorAll('.shop-hero-slide'));
    const bgs = Array.from(root.querySelectorAll('.shop-hero-bg-item'));
    const ctas = Array.from(root.querySelectorAll('.shop-hero-cta'));
    const nums = Array.from(root.querySelectorAll('.shop-hero-counter-num'));
    const progressBar = root.querySelector('.shop-hero-progress-bar');
    const prevBtn = root.querySelector('.shop-hero-prev');
    const nextBtn = root.querySelector('.shop-hero-next');

    const total = slides.length;
    if (total === 0) return;
    


    const shouldAutoplay = root.dataset.autoplay === 'true' && total > 1;
    const intervalMs = parseInt(root.dataset.interval, 10) || 6000;

    let index = 0;
    let paused = false;
    let progressStart = 0;
    let progressElapsed = 0;
    let progressRaf = null;
    let nextTimer = null;

    const setCounter = () => {
      const prevIdx = (index - 1 + total) % total;
      const nextIdx = (index + 1) % total;
      nums.forEach((el, i) => {
        el.classList.toggle('is-current', i === index);
        el.classList.toggle('is-prev', i === prevIdx && total > 1 && i !== index);
        el.classList.toggle('is-next', i === nextIdx && total > 2 && i !== index && i !== prevIdx);
      });
    };

    const render = () => {
      slides.forEach((s, i) => {
        s.classList.toggle('is-active', i === index);
        s.setAttribute(
          'aria-hidden',
          i === index
            ? 'false'
            : 'true'
        );
      });
      bgs.forEach((b, i) => b.classList.toggle('is-active', i === index));
      ctas.forEach((c, i) => c.classList.toggle('is-active', i === index));
      setCounter();
    };

    const stopProgress = () => {
      if (progressRaf) 
        cancelAnimationFrame(progressRaf);
      


      progressRaf = null;
    };

    const resetProgress = () => {
      stopProgress();
      progressElapsed = 0;
      if (progressBar) 
        progressBar.style.width = '0%';
      
    };

    const tickProgress = (now) => {
      if (paused) return;
      
      const elapsed = progressElapsed + (now - progressStart);
      const pct = Math.min(100, (elapsed / intervalMs) * 100);
      if (progressBar) 
        progressBar.style.width = pct + '%';
      
      if (pct >= 100) {
        go(1);
        return;
      }
      progressRaf = requestAnimationFrame(tickProgress);
    };

    const startProgress = () => {
      if (! shouldAutoplay || paused) return;
      
      stopProgress();
      progressStart = performance.now();
      progressRaf = requestAnimationFrame(tickProgress);
    };

    const goTo = (i) => {
      const next = ((i % total) + total) % total;
      if (next === index) return;
      


      index = next;
      render();
      resetProgress();
      startProgress();
    };

    const go = (dir) => goTo(index + dir);

    const pause = () => {
      if (paused) return;
      
      paused = true;

// Bank the time that's passed on the current tick so we can resume from it
      if (progressStart > 0) {
        progressElapsed += performance.now() - progressStart;
      }
      stopProgress();
    };

    const resume = () => {
      if (! paused) return;
      
      paused = false;
      if (! shouldAutoplay) return;
      
      progressStart = performance.now();
      progressRaf = requestAnimationFrame(tickProgress);
    };

    prevBtn ?. addEventListener('click', () => go(-1));
    nextBtn ?. addEventListener('click', () => go(1));

    root.addEventListener('mouseenter', pause);
    root.addEventListener('mouseleave', resume);
    root.addEventListener('focusin', pause);
    root.addEventListener('focusout', (e) => {
      if (!root.contains(e.relatedTarget)) 
        resume();
      


    });
    document.addEventListener('visibilitychange', () => {
      if (document.hidden) 
        pause();
       else 
        resume();
      


    });

    root.addEventListener('keydown', (e) => {
      if (e.key === 'ArrowLeft') {
        e.preventDefault();
        go(-1);
      } else if (e.key === 'ArrowRight') {
        e.preventDefault();
        go(1);
      }
    });

    document.addEventListener('shopify:block:select', (e) => {
      const i = slides.findIndex((s) => s.contains(e.target) || s === e.target);
      if (i >= 0) {
        pause();
        goTo(i);
      }
    });
    document.addEventListener('shopify:block:deselect', () => resume());

// Pause autoplay when the hero is off-screen to save resources
    if ('IntersectionObserver' in window) {
      const io = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) 
            resume();
           else 
            pause();
          
        });
      }, {threshold: 0});
      io.observe(root);
    }

    render();
    startProgress();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["section-shopthelook"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-shopthelook]').forEach((root) => {
    const looks = Array.from(root.querySelectorAll('.look-item'));
    const hotspotDots = Array.from(root.querySelectorAll('.look-hotspot-dot'));
    const switcher = root.querySelector('[data-shopthelook-switcher]');

    if (looks.length === 0) return;

    // Build mobile product slider from each look's rendered hotspots + wire its prev/next chevrons
    looks.forEach((look) => {
      const slider = look.querySelector('[data-mobile-slider]');
      if (!slider) return;
      const hotspots = look.querySelectorAll('.look-hotspot[data-hotspot-id]');
      slider.innerHTML = '';
      hotspots.forEach((hotspot) => {
        const card = hotspot.querySelector('.product-card-look');
        if (!card) return;
        const wrapper = document.createElement('div');
        wrapper.className = 'look-products-mobile-card';
        wrapper.dataset.hotspotId = hotspot.dataset.hotspotId;
        const clone = card.cloneNode(true);
        clone.classList.remove('look-hotspot-card');
        wrapper.appendChild(clone);
        slider.appendChild(wrapper);
      });

      // Prev/next chevrons
      const prevBtn = look.querySelector('[data-slider-prev]');
      const nextBtn = look.querySelector('[data-slider-next]');

      const stepSize = () => {
        const firstCard = slider.querySelector('.look-products-mobile-card');
        const gap = parseFloat(getComputedStyle(slider).gap) || 0;
        return (firstCard?.offsetWidth || 0) + gap;
      };

      const updateNav = () => {
        if (!prevBtn || !nextBtn) return;
        const max = slider.scrollWidth - slider.clientWidth;
        prevBtn.disabled = slider.scrollLeft <= 2;
        nextBtn.disabled = slider.scrollLeft >= max - 2;
      };

      prevBtn?.addEventListener('click', () => {
        slider.scrollBy({ left: -stepSize(), behavior: 'smooth' });
      });
      nextBtn?.addEventListener('click', () => {
        slider.scrollBy({ left: stepSize(), behavior: 'smooth' });
      });

      slider.addEventListener('scroll', updateNav, { passive: true });
      // Initial state once cards are in place
      requestAnimationFrame(updateNav);
    });

    // Build switcher tabs dynamically from rendered looks
    const btns = [];
    if (switcher) {
      switcher.innerHTML = '';
      looks.forEach((look, i) => {
        const btn = document.createElement('button');
        btn.type = 'button';
        btn.className =
          'shopthelook-switcher-btn py-1.5 md:py-2 px-3 md:px-4 rounded-full bg-shop/5 border-shop border text-shop md:pb-2 transition-colors duration-200 cursor-pointer' +
          (i === 0 ? ' is-active' : '');
        btn.dataset.index = String(i);
        const title = look.dataset.title || 'Look';
        btn.textContent = `${title}`;
        switcher.appendChild(btn);
        btns.push(btn);
      });
    }

    let active = 0;

    const render = () => {
      looks.forEach((el, i) => el.classList.toggle('is-active', i === active));
      btns.forEach((el, i) => el.classList.toggle('is-active', i === active));

// Collapse any open hotspot popups when switching looks
      hotspotDots.forEach((dot) => dot.setAttribute('aria-expanded', 'false'));
    };

    btns.forEach((btn, i) => {
      btn.addEventListener('click', () => {
        active = i;
        render();
      });
    });

// Hotspot click: desktop toggles popup, mobile scrolls to matching product card
    const desktopMq = window.matchMedia('(min-width: 1024px)');
    hotspotDots.forEach((dot) => {
      dot.addEventListener('click', (e) => {
        e.stopPropagation();

        if (desktopMq.matches) {
          const willOpen = dot.getAttribute('aria-expanded') !== 'true';
          hotspotDots.forEach((d) => d.setAttribute('aria-expanded', 'false'));
          dot.setAttribute('aria-expanded', willOpen ? 'true' : 'false');
          return;
        }

        // Mobile: scroll the matching card into view inside the same look
        const hotspot = dot.closest('.look-hotspot');
        const look = dot.closest('.look-item');
        const id = hotspot?.dataset.hotspotId;
        if (!id || !look) return;
        const target = look.querySelector(
          `.look-products-mobile-card[data-hotspot-id="${id}"]`
        );
        if (!target) return;

        target.scrollIntoView({ behavior: 'smooth', block: 'center', inline: 'center' });
        target.classList.add('is-target');
        setTimeout(() => target.classList.remove('is-target'), 1500);
      });
    });

    document.addEventListener('click', (e) => {
      if (!root.contains(e.target)) {
        hotspotDots.forEach((d) => d.setAttribute('aria-expanded', 'false'));
      }
    });

// Keep selection in sync with the theme editor block selection
    document.addEventListener('shopify:block:select', (e) => {
      const i = looks.findIndex((l) => l.contains(e.target) || l === e.target);
      if (i >= 0 && i !== active) {
        active = i;
        render();
      }
    });

    render();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["section-showroom"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-showroom]').forEach((track) => {
    const video = track.querySelector('video');
    if (!video) return;

    const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (reduced) {
      video.play?.().catch(() => {});
      return;
    }

    video.muted = true;
    video.playsInline = true;
    video.preload = 'auto';
    video.removeAttribute('autoplay');
    video.removeAttribute('loop');
    // Force the browser to begin fetching metadata + frames
    try {
      video.load();
    } catch (e) {}

    const pxPerSec = parseFloat(track.dataset.pxPerSec) || 200;

    const isReady = () => Number.isFinite(video.duration) && video.duration > 0;

    let initialized = false;
    let raf = null;
    // Cache values written into CSS / video so we skip no-op writes on
    // every rAF. Writing CSS vars + reading getBoundingClientRect even
    // when nothing changed is itself measurable jank.
    let lastEased = -1;
    let lastSeekTarget = -1;
    // Decoder back-pressure flag: we won't queue a new seek until the
    // previous one has been displayed (signalled by
    // requestVideoFrameCallback). This prevents seek-queue overflow on
    // fast scroll where the decoder can't keep up.
    let seekPending = false;
    const supportsVFC = typeof video.requestVideoFrameCallback === 'function';

    const RAMP = 0.15; // 15% entry + 15% exit for the contained-card morph
    // Seek deadband — only push a new currentTime if the delta is at
    // least ~1.5 frames at 24fps. Tighter = smoother visuals at the cost
    // of more decoder work; looser = lighter load but visible stepping.
    const SEEK_THRESHOLD = 0.05;

    // Start-offset: hold the video on frame 0 until the section is this
    // fraction of the viewport scrolled in, then begin scrubbing. The extra
    // distance is added to the track height so scrub speed (px/sec) is unchanged.
    const TRIGGER_OFFSET_VH = 0.25;
    // Minimum track height in viewports (1 = pin height, extra = sticky scrub room).
    const MIN_TRACK_VH = 1.5;

    const setTrackHeight = () => {
      if (!isReady()) return;
      const vh = window.innerHeight || document.documentElement.clientHeight;
      // The formula shrinks as vh grows; on tall viewports / zoomed-out
      // browsers it dropped below the 100vh pin, so the pin spilled out of
      // the track and the cards below scrolled over the video. Floor it at
      // vh * MIN_TRACK_VH so there's always a sticky phase.
      const trackH = Math.max(vh * MIN_TRACK_VH, video.duration * pxPerSec - vh + vh * TRIGGER_OFFSET_VH);
      track.style.setProperty('--showroom-track-height', `${trackH}px`);
    };

    const update = () => {
      raf = null;
      if (!isReady()) return;
      const rect = track.getBoundingClientRect();
      const vh = window.innerHeight || document.documentElement.clientHeight;
      const offset = vh * TRIGGER_OFFSET_VH;
      const range = vh + rect.height;
      const p = Math.max(0, Math.min(1, (vh - rect.top - offset) / (range - offset)));

      // Eased progress: 1 at entry/exit (contained card), 0 in the
      // middle (fullscreen).
      let eased;
      if (p < RAMP) eased = 1 - p / RAMP;
      else if (p > 1 - RAMP) eased = (p - (1 - RAMP)) / RAMP;
      else eased = 0;

      // Skip CSS-var write when nothing changed (4 decimal precision is
      // enough — sub-pixel differences are invisible).
      const easedQuant = Math.round(eased * 10000) / 10000;
      if (easedQuant !== lastEased) {
        lastEased = easedQuant;
        track.style.setProperty('--showroom-eased-p', easedQuant.toFixed(4));
      }

      const t = p * video.duration;
      // Drop the seek when (a) the delta is smaller than the deadband,
      // (b) a previous seek hasn't been painted yet (decoder still
      // working). Both protect the decoder from queue-thrashing on fast
      // scroll.
      if (!seekPending && Math.abs(video.currentTime - t) > SEEK_THRESHOLD && t !== lastSeekTarget) {
        lastSeekTarget = t;
        seekPending = true;
        try {
          video.currentTime = t;
        } catch (e) {
          seekPending = false;
        }
        if (supportsVFC) {
          video.requestVideoFrameCallback(() => {
            seekPending = false;
          });
        } else {
          // Fallback: assume a worst-case ~33ms (one 30fps frame) before
          // the next seek is safe.
          setTimeout(() => { seekPending = false; }, 33);
        }
      }
    };

    const onScroll = () => {
      if (raf) return;
      raf = requestAnimationFrame(update);
    };

    const init = () => {
      if (initialized || !isReady()) return;
      initialized = true;
      try {
        video.pause();
      } catch (e) {}
      setTrackHeight();
      update();
      // Stop listening once duration is known — these events can fire
      // multiple times on some browsers and the listener is no longer
      // useful after first init.
      readyEvents.forEach((ev) => video.removeEventListener(ev, init));
    };

    const readyEvents = ['loadedmetadata', 'durationchange', 'canplay', 'canplaythrough', 'loadeddata'];
    readyEvents.forEach((ev) => video.addEventListener(ev, init));

    // Watchdog for the case where none of those events fire on first
    // load (data-saver mode, codec quirks). Poll every 100ms; nudge
    // load() every 15 polls (~1.5s) for at most 15s total.
    let pollAttempts = 0;
    const pollForReady = () => {
      if (initialized) return;
      if (isReady()) {
        init();
        return;
      }
      pollAttempts++;
      if (pollAttempts % 15 === 0 && pollAttempts <= 150) {
        try {
          video.load();
        } catch (e) {}
      }
      if (pollAttempts < 150) setTimeout(pollForReady, 100);
    };
    pollForReady();

    if ('IntersectionObserver' in window) {
      const io = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting && !initialized) {
              try {
                video.load();
              } catch (e) {}
            }
          });
        },
        { rootMargin: '200% 0px' }
      );
      io.observe(track);
    }

    window.addEventListener('scroll', onScroll, { passive: true });

    // Debounce resize — the bare handler used to fire dozens of times
    // during a window drag and re-running setTrackHeight + update on
    // each one was wasted work.
    let resizeTimer = null;
    window.addEventListener(
      'resize',
      () => {
        if (resizeTimer) clearTimeout(resizeTimer);
        resizeTimer = setTimeout(() => {
          resizeTimer = null;
          setTrackHeight();
          onScroll();
        }, 80);
      },
      { passive: true }
    );
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["section-studio-hero"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-studio-hero]').forEach((root) => {
    const bgs = Array.from(root.querySelectorAll('.studio-hero-bg-item'));
    const infos = Array.from(root.querySelectorAll('.studio-hero-info'));
    const rows = Array.from(root.querySelectorAll('.studio-hero-row'));
    const total = rows.length;
    if (total === 0) return;

    const shouldAutoplay = root.dataset.autoplay === 'true' && total > 1;
    const intervalMs = parseInt(root.dataset.interval, 10) || 6000;

    let index = 0;
    let paused = false;
    let progressStart = 0;
    let progressElapsed = 0;
    let raf = null;

    const setBar = (i, p) => {
      const r = rows[i];
      if (r) r.style.setProperty('--studio-bar-p', p.toFixed(4));
    };

    const resetBars = () => {
      rows.forEach((_, i) => setBar(i, 0));
    };

    const render = () => {
      bgs.forEach((b, i) => b.classList.toggle('is-active', i === index));
      rows.forEach((r, i) => r.classList.toggle('is-active', i === index));
      infos.forEach((it, i) => {
        it.classList.toggle('is-active', i === index);
        const link = it.querySelector('.studio-hero-name-link');
        if (link) link.tabIndex = i === index ? 0 : -1;
      });
    };

    const stopProgress = () => {
      if (raf) cancelAnimationFrame(raf);
      raf = null;
    };

    const tickProgress = (now) => {
      if (paused) return;
      const elapsed = progressElapsed + (now - progressStart);
      const p = Math.min(1, elapsed / intervalMs);
      setBar(index, p);
      if (p >= 1) {
        index = (index + 1) % total;
        render();
        startProgress();
        return;
      }
      raf = requestAnimationFrame(tickProgress);
    };

    const startProgress = () => {
      stopProgress();
      progressElapsed = 0;
      resetBars();
      if (!shouldAutoplay || paused) return;
      progressStart = performance.now();
      raf = requestAnimationFrame(tickProgress);
    };

    const goTo = (i) => {
      const next = ((i % total) + total) % total;
      if (next === index) return;
      index = next;
      render();
      startProgress();
    };

    rows.forEach((row, i) => {
      row.addEventListener('click', () => {
        if (i === index) {
          const href = row.dataset.href;
          if (href && href !== '#') window.location.href = href;
          return;
        }
        goTo(i);
      });
    });

    const pause = () => {
      if (paused) return;
      paused = true;
      if (progressStart > 0) {
        progressElapsed += performance.now() - progressStart;
      }
      stopProgress();
    };

    const resume = () => {
      if (!paused) return;
      paused = false;
      if (!shouldAutoplay) return;
      progressStart = performance.now();
      raf = requestAnimationFrame(tickProgress);
    };

    root.addEventListener('mouseenter', pause);
    root.addEventListener('mouseleave', resume);
    root.addEventListener('focusin', pause);
    root.addEventListener('focusout', (e) => {
      if (!root.contains(e.relatedTarget)) resume();
    });
    document.addEventListener('visibilitychange', () => {
      if (document.hidden) pause();
      else resume();
    });

    root.addEventListener('keydown', (e) => {
      if (e.key === 'ArrowDown' || e.key === 'ArrowRight') {
        e.preventDefault();
        goTo(index + 1);
      } else if (e.key === 'ArrowUp' || e.key === 'ArrowLeft') {
        e.preventDefault();
        goTo(index - 1);
      }
    });

    if ('IntersectionObserver' in window) {
      const io = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) resume();
            else pause();
          });
        },
        { threshold: 0 }
      );
      io.observe(root);
    }

    render();
    startProgress();
  });

  } catch(e) { console.error(e); }
})();
})();
